import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traducciones
const resources = {
  es: {
    translation: {
      // Header
      "header.home": "Inicio",
      "header.features": "Características",
      "header.howItWorks": "Cómo Funciona",
      "header.testimonials": "Problemas",
      "header.faq": "FAQ",
      "header.signup": "Únete",
      "header.backToTenku": "Volver a Tenku",
      "header.openWeb": "Entrar a la web",

      // Hero
      "hero.title": "Conecta con tu",
      "hero.titleHighlight": "Comunidad Deportiva",
      "hero.subtitle": "Descubre juegos cerca de ti, organiza equipos y torneos, y conecta con otros deportistas. Tu próximo juego está a un toque de distancia.",
      "hero.ctaPrimary": "Descargar Ahora",
      "hero.ctaSecondary": "Conocer Más",
      "hero.ctaWeb": "Usar en el navegador",
      "hero.nowAvailable": "¡Disponible Ahora!",
      "hero.downloadSubtitle": "Descarga la app en iOS o Android, o entra desde el navegador, y conecta con tu comunidad deportiva hoy mismo.",
      "hero.badge": "Disponible en iOS, Android y web",
      "hero.cardGame.title": "Pichanga 7v7",
      "hero.cardGame.meta": "8/14 jugadores · Hoy 8:00 PM",
      "hero.cardNear.title": "Cerca de ti",
      "hero.cardNear.meta": "A 1.2 km · 5 juegos abiertos",

      // Features
      "features.title": "Todo lo que Necesitas para Jugar",
      "features.subtitle": "Tenku te ofrece todas las herramientas para conectar con otros deportistas, organizar juegos y hacer crecer tu pasión por el deporte.",
      "features.findGames.title": "Encuentra Juegos Cerca",
      "features.findGames.description": "Usa nuestro mapa interactivo para descubrir juegos y eventos deportivos en tu área al instante.",
      "features.organizeTeams.title": "Organiza Tus Equipos",
      "features.organizeTeams.description": "Crea perfiles para tus equipos, invita a jugadores y gestiona tu plantilla de forma sencilla.",
      "features.tournaments.title": "Organiza Torneos",
      "features.tournaments.description": "Crea tu torneo, invita a los equipos y lleva el fixture, los resultados y la tabla de posiciones desde la app.",
      "features.lineups.title": "Formaciones y Alineaciones",
      "features.lineups.description": "Arma la alineación de tu equipo sobre la cancha, asigna posiciones y compártela antes de cada partido.",
      "features.arrival.title": "Sigue el Partido en Vivo",
      "features.arrival.description": "Confirma tu llegada con un toque y mira en tiempo real quién ya está en la cancha, incluso desde la pantalla de bloqueo.",
      "features.chat.title": "Chat Integrado",
      "features.chat.description": "Cada juego y cada equipo tienen su propio chat: coordina todo en un solo lugar, sin cadenas interminables de mensajes.",
      "features.playerSearch.title": "Encuentra Jugadores",
      "features.playerSearch.description": "Busca deportistas por deporte, revisa su perfil y conecta para tu próximo partido.",
      "features.notifications.title": "Notificaciones en Tiempo Real",
      "features.notifications.description": "Recibe alertas sobre nuevos juegos, invitaciones de equipo y mensajes de otros jugadores.",
      "features.personalStats.title": "Estadísticas Personales",
      "features.personalStats.description": "Lleva un registro de tus juegos, mejora tu rendimiento y comparte tus logros con la comunidad.",
      "features.booking.title": "Reserva tu Cancha",
      "features.booking.description": "Abre el link de tu local, elige un horario libre y envía tu reserva desde la app. El local la confirma y sigues su estado en Mis reservas.",

      // How It Works
      "howItWorks.title": "¿Cómo Funciona?",
      "howItWorks.subtitle": "En solo tres pasos sencillos estarás conectado con la comunidad deportiva de tu ciudad.",
      "howItWorks.step1.title": "Crea tu Perfil",
      "howItWorks.step1.description": "Regístrate y completa tu perfil deportivo con tus deportes favoritos y nivel de habilidad.",
      "howItWorks.step2.title": "Busca o Crea Juegos",
      "howItWorks.step2.description": "Explora juegos cerca de ti o crea los tuyos propios para que otros se unan.",
      "howItWorks.step3.title": "Conecta y Juega",
      "howItWorks.step3.description": "Únete a juegos, conoce nuevos deportistas y disfruta jugando tu deporte favorito.",

      // Testimonials
      "testimonials.title": "¿Te Suena Familiar?",
      "testimonials.subtitle": "Estos son los problemas más comunes que enfrentan los deportistas hoy en día.",
      "testimonials.subtitleHighlight": " Tenku los resuelve todos.",
      "testimonials.problem1.title": "Equipos Incompletos",
      "testimonials.problem1.description": "Siempre falta alguien. Organizas un juego de fútbol y solo llegan 6 personas. ¡Imposible jugar!",
      "testimonials.problem2.title": "Sin Compañeros de Juego",
      "testimonials.problem2.description": "Quiero jugar tenis pero mis amigos siempre están ocupados. Termino entrenando solo otra vez.",
      "testimonials.problem3.title": "Coordinación Imposible",
      "testimonials.problem3.description": "WhatsApp lleno de mensajes para organizar UN juego. Nadie se pone de acuerdo con el horario.",
      "testimonials.problem4.title": "Canchas Vacías",
      "testimonials.problem4.description": "Llego a la cancha y no hay nadie jugando. Me hubiera gustado unirme a algún grupo.",
      "testimonials.problem5.title": "Horarios Limitados",
      "testimonials.problem5.description": "Solo puedo jugar ciertos días pero mi grupo habitual no coincide. Mi tiempo libre se desperdicia.",
      "testimonials.problem6.title": "Ciudad Nueva",
      "testimonials.problem6.description": "Me mudé y no conozco a nadie que juegue mi deporte favorito. ¿Cómo encuentro gente aquí?",

      // Downloads
      "downloads.title": "¡Descarga Tenku Ahora!",
      "downloads.subtitle": "La app está disponible en iOS y Android, y también puedes usarla desde el navegador sin instalar nada. ¡Únete a nuestra comunidad de deportistas hoy mismo!",
      "downloads.downloadOn": "Descargar en",
      "downloads.appStore": "App Store",
      "downloads.googlePlay": "Google Play",
      "downloads.appStoreLink": "https://apps.apple.com/pe/app/sports-nest/id6753092450",
      "downloads.googlePlayLink": "https://play.google.com/store/apps/details?id=com.jabanto.sportsnest",
      "downloads.availableNow": "✅ La aplicación está disponible ahora en ambas plataformas",
      "downloads.scanQr": "Escanea el código con la cámara de tu teléfono para descargar la app.",
      "downloads.webLabel": "Sin instalar",
      "downloads.webName": "Versión web",
      "downloads.webLink": "https://app.tenkusports.com",
      "downloads.webNote": "Ideal si tu teléfono no es compatible con la app o si organizas torneos desde la laptop.",
      "downloads.betaNotice": "📱 Disponible ahora en iOS y Android",

      // FAQ
      "faq.title": "Preguntas Frecuentes",
      "faq.subtitle": "Resolvemos las dudas más comunes sobre Tenku.",
      "faq.q1.question": "¿Puedo unirme a un juego si soy principiante?",
      "faq.q1.answer": "¡Por supuesto! En Tenku puedes filtrar juegos por nivel de habilidad. Hay una comunidad acogedora para todos, desde principiantes hasta jugadores avanzados.",
      "faq.q2.question": "¿Cómo funciona la creación de equipos?",
      "faq.q2.answer": "Puedes crear el perfil de tu equipo, invitar jugadores con un enlace, gestionar tu plantilla y armar la formación para cada partido.",
      "faq.q3.question": "¿Es seguro encontrarme con gente a través de la app?",
      "faq.q3.answer": "La seguridad es nuestra prioridad. Contamos con perfiles verificados, un sistema de calificación de jugadores y te recomendamos jugar siempre en lugares públicos y conocidos.",
      "faq.q4.question": "¿Tenku estará disponible en mi ciudad?",
      "faq.q4.answer": "Tenku funcionará en cualquier ciudad desde el día uno. La comunidad deportiva de cada lugar crecerá orgánicamente: mientras más usuarios inviten a sus amigos, más activa será la red local. ¡Sé el pionero en tu ciudad!",
      "faq.q5.question": "¿Puedo organizar un torneo en Tenku?",
      "faq.q5.answer": "Sí. Crea tu torneo, invita a los equipos y gestiona el fixture, los resultados y la tabla de posiciones directamente desde la app.",
      "faq.q6.question": "¿La aplicación es gratuita?",
      "faq.q6.answer": "Sí, Tenku es gratuita. Puedes encontrar juegos, crear equipos y organizar torneos sin pagar nada.",
      "faq.q7.question": "¿Mi teléfono no es compatible con la app?",
      "faq.q7.answer": "Puedes usar Tenku desde el navegador en app.tenkusports.com con la misma cuenta: buscar juegos y torneos, inscribir a tu equipo, aceptar invitaciones y organizar tus torneos. El chat y algunas funciones quedan solo en la app.",

      // Footer
      "footer.description": "Conectando deportistas y creando comunidades deportivas en todo el mundo. Tu próximo juego está a un toque de distancia.",
      "footer.copyright": "© {{year}} Tenku. Todos los derechos reservados.",
      "footer.product": "Producto",
      "footer.legal": "Legal",
      "footer.tagline": "Juega sin excusas",
      "footer.forVenues": "¿Administras una cancha?",
      "footer.forPlayers": "¿Eres jugador? Conoce la app",
      "footer.descriptionVenues": "Reservas, cobros y clientes de tu cancha en un solo lugar, y jugadores que te encuentran en Tenku.",
      "footer.webApp": "Usar Tenku en el navegador",

      // Legal pages
      "legal.privacyTitle": "Política de Privacidad",
      "legal.termsTitle": "Términos y Condiciones",
      "legal.lastUpdated": "Última actualización:",

      // Privacy Policy
      "privacy.section1.title": "1. Información que Recopilamos",
      "privacy.section1.intro": "En Tenku, recopilamos la siguiente información para brindarte una mejor experiencia:",
      "privacy.section1.accountInfo": "Información de cuenta: nombre, email, edad, foto de perfil",
      "privacy.section1.sportsInfo": "Información deportiva: deportes favoritos, nivel de habilidad, disponibilidad",
      "privacy.section1.locationInfo": "Información de ubicación: ubicación aproximada para mostrarte juegos cerca de ti (solo cuando uses la app)",
      "privacy.section1.commInfo": "Datos de comunicación: mensajes con otros usuarios, invitaciones",
      "privacy.section1.usageInfo": "Datos de uso: cómo interactúas con la app, preferencias, estadísticas de juego",
      "privacy.section1.deviceInfo": "Información del dispositivo: identificador único, sistema operativo, tipo de dispositivo",
      "privacy.section1.authInfo": "Datos de autenticación: información de Apple ID, Google, Facebook si usas login social",

      "privacy.section2.title": "2. Cómo Utilizamos tu Información",
      "privacy.section2.intro": "Utilizamos tu información para:",
      "privacy.section2.connect": "Conectarte con otros deportistas en tu área",
      "privacy.section2.showGames": "Mostrarte juegos y eventos relevantes",
      "privacy.section2.notifications": "Enviar notificaciones sobre invitaciones y actualizaciones",
      "privacy.section2.security": "Mejorar la seguridad y funcionalidad de la aplicación",
      "privacy.section2.support": "Proporcionar soporte técnico cuando lo necesites",

      "privacy.section3.title": "3. Compartir Información",
      "privacy.section3.intro": "No vendemos ni alquilamos tu información personal. Compartimos información limitada solo cuando:",
      "privacy.section3.necessary": "Es necesario para conectarte con otros usuarios de la aplicación",
      "privacy.section3.legal": "Lo requiere la ley o autoridades competentes",
      "privacy.section3.safety": "Es necesario para proteger la seguridad de nuestros usuarios",

      "privacy.section4.title": "4. Seguridad de Datos",
      "privacy.section4.intro": "Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal:",
      "privacy.section4.encryption": "Encriptación de datos en tránsito y en reposo",
      "privacy.section4.auth": "Autenticación segura y tokens de acceso",
      "privacy.section4.servers": "Servidores seguros con acceso limitado",
      "privacy.section4.monitoring": "Monitoreo continuo de seguridad",
      "privacy.section4.compliance": "Cumplimiento con estándares de la industria",

      "privacy.section5.title": "5. Retención de Datos",
      "privacy.section5.intro": "Retenemos tu información personal solo mientras sea necesario para:",
      "privacy.section5.services": "Proporcionar nuestros servicios",
      "privacy.section5.legal": "Cumplir con obligaciones legales",
      "privacy.section5.disputes": "Resolver disputas",
      "privacy.section5.deletion": "Si eliminas tu cuenta, eliminaremos tu información dentro de 30 días",

      "privacy.section6.title": "6. Transferencias Internacionales",
      "privacy.section6.content": "Tus datos pueden ser procesados en servidores ubicados fuera de tu país de residencia. Garantizamos el mismo nivel de protección mediante acuerdos de transferencia de datos apropiados.",

      "privacy.section7.title": "7. Menores de Edad",
      "privacy.section7.content": "Tenku no está dirigida a menores de 13 años. No recopilamos intencionalmente información personal de niños menores de 13 años. Si descubrimos que hemos recopilado información de un menor de 13 años, la eliminaremos inmediatamente.",

      "privacy.section8.title": "8. Tus Derechos",
      "privacy.section8.intro": "Tienes derecho a:",
      "privacy.section8.access": "Acceder a tu información personal",
      "privacy.section8.correct": "Corregir información incorrecta",
      "privacy.section8.delete": "Eliminar tu cuenta y datos",
      "privacy.section8.portability": "Portabilidad de tus datos",
      "privacy.section8.object": "Oponerte al procesamiento de tus datos",

      "privacy.section9.title": "9. Cambios a esta Política",
      "privacy.section9.content": "Podemos actualizar esta política de privacidad ocasionalmente. Te notificaremos sobre cambios significativos a través de la aplicación o por email. Tu uso continuado de Tenku después de los cambios constituye tu aceptación de la nueva política.",

      "privacy.section10.title": "10. Contacto",
      "privacy.section10.content": "Si tienes preguntas sobre esta política de privacidad, contáctanos en:",
      "privacy.section10.email": "Email: privacy@tenkusports.com",

      // Terms
      "terms.section1.title": "1. Aceptación de Términos",
      "terms.section1.content": "Al acceder y utilizar Tenku, aceptas estar legalmente vinculado por estos términos y condiciones. Si no estás de acuerdo con alguno de estos términos, no utilices nuestros servicios.",

      "terms.section2.title": "2. Descripción del Servicio",
      "terms.section2.intro": "Tenku es una plataforma que conecta deportistas y entusiastas del deporte para:",
      "terms.section2.find": "Encontrar y unirse a juegos deportivos locales",
      "terms.section2.organize": "Organizar equipos y eventos deportivos",
      "terms.section2.connect": "Conectar con otros deportistas en tu área",
      "terms.section2.participate": "Participar en torneos y competencias",

      "terms.section3.title": "3. Registro y Cuenta de Usuario",
      "terms.section3.intro": "Para utilizar Tenku, debes:",
      "terms.section3.age": "Ser mayor de 13 años (menores necesitan consentimiento parental)",
      "terms.section3.accurate": "Proporcionar información precisa y actualizada",
      "terms.section3.security": "Mantener la seguridad de tu cuenta y contraseña",
      "terms.section3.notify": "Notificar inmediatamente cualquier uso no autorizado",

      "terms.section4.title": "4. Conducta del Usuario",
      "terms.section4.intro": "Al usar Tenku, te comprometes a:",
      "terms.section4.respectful": "Comportarte de manera respetuosa con otros usuarios",
      "terms.section4.noOffensive": "No publicar contenido ofensivo, discriminatorio, violento o inapropiado",
      "terms.section4.noIllegal": "No usar la plataforma para actividades ilegales o fraudulentas",
      "terms.section4.noHarass": "No acosar, intimidar o amenazar a otros usuarios",
      "terms.section4.noFake": "No crear cuentas falsas o suplantar a otras personas",
      "terms.section4.noSpam": "No enviar spam o contenido promocional no solicitado",
      "terms.section4.ip": "Respetar la propiedad intelectual de terceros",
      "terms.section4.noInterfere": "No interferir con el funcionamiento de la aplicación",
      "terms.section4.rules": "Cumplir con las reglas específicas de cada evento deportivo",

      "terms.section5.title": "5. Seguridad y Responsabilidad",
      "terms.section5.important": "Importante:",
      "terms.section5.intro": "La participación en actividades deportivas conlleva riesgos inherentes. Al usar Tenku:",
      "terms.section5.ownRisk": "Participas bajo tu propia responsabilidad",
      "terms.section5.insurance": "Debes tener el seguro médico apropiado",
      "terms.section5.notResponsible": "Tenku no es responsable por lesiones o daños",
      "terms.section5.recommend": "Recomendamos conocer a otros usuarios en lugares públicos",

      "terms.section6.title": "6. Contenido del Usuario",
      "terms.section6.content": "Al publicar contenido en Tenku (fotos, mensajes, etc.), otorgas a Tenku una licencia limitada para mostrar ese contenido dentro de la aplicación. Conservas todos los derechos sobre tu contenido y puedes eliminarlo en cualquier momento.",

      "terms.section7.title": "7. Propiedad Intelectual",
      "terms.section7.content": "Tenku y todo su contenido (diseño, código, logos, textos) son propiedad de la empresa y están protegidos por las leyes de propiedad intelectual. No puedes copiar, modificar o distribuir ningún contenido de la aplicación sin autorización expresa.",

      "terms.section8.title": "8. Pagos y Suscripciones",
      "terms.section8.content": "Tenku ofrece funciones básicas gratuitas y funciones premium de pago. Los pagos se procesan a través de Apple App Store o Google Play Store. Las políticas de reembolso están sujetas a los términos de estas plataformas.",

      "terms.section9.title": "9. Limitación de Responsabilidad",
      "terms.section9.content": "Tenku se proporciona \"tal como está\". No garantizamos que el servicio sea ininterrumpido o libre de errores. Nuestra responsabilidad está limitada al máximo permitido por la ley.",

      "terms.section10.title": "10. Ley Aplicable y Jurisdicción",
      "terms.section10.content": "Estos términos se rigen por las leyes del país donde opera Tenku. Cualquier disputa será resuelta mediante arbitraje o en los tribunales competentes de dicha jurisdicción.",

      "terms.section11.title": "11. Modificaciones",
      "terms.section11.content": "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios significativos serán notificados a través de la aplicación.",

      "terms.section12.title": "12. Terminación",
      "terms.section12.content": "Podemos terminar o suspender tu cuenta en cualquier momento por violación de estos términos. También puedes eliminar tu cuenta en cualquier momento desde la configuración de la aplicación.",

      "terms.section13.title": "13. Contacto",
      "terms.section13.content": "Si tienes preguntas sobre estos términos, contáctanos en:",
      "terms.section13.email": "Email: legal@tenkusports.com",

      // Support
      "support.title": "Soporte",
      "support.subtitle": "Estamos aquí para ayudarte con cualquier consulta sobre Tenku.",
      "support.deleteAccount.title": "Eliminación de Cuenta",
      "support.deleteAccount.description": "Si deseas eliminar permanentemente tu cuenta de Tenku y todos los datos asociados, puedes solicitarlo siguiendo estos pasos:",
      "support.deleteAccount.steps.title": "Pasos para eliminar tu cuenta:",
      "support.deleteAccount.steps.step1": "Envía un correo electrónico a support@tenkusports.com",
      "support.deleteAccount.steps.step2": "Incluye en el asunto: 'Solicitud de eliminación de cuenta'",
      "support.deleteAccount.steps.step3": "Proporciona tu email registrado y confirma que deseas eliminar permanentemente tu cuenta",
      "support.deleteAccount.thirdParty.title": "Cuentas vinculadas con terceros",
      "support.deleteAccount.thirdParty.description": "Si te registraste usando servicios de terceros, también procesaremos la desvinculación automáticamente:",
      "support.deleteAccount.thirdParty.google": "Se desvinculará automáticamente de tu cuenta de Google",
      "support.deleteAccount.thirdParty.facebook": "Se desvinculará automáticamente de tu cuenta de Facebook",
      "support.deleteAccount.warning.title": "Importante",
      "support.deleteAccount.warning.description": "Esta acción es irreversible. Todos tus datos, juegos, conexiones y información de perfil serán eliminados permanentemente.",
      "support.contactButton": "Contactar Soporte",

      // 404 Page
      "notFound.title": "¡Ups! Página no encontrada",
      "notFound.subtitle": "Parece que esta página se fue a jugar a otro campo",
      "notFound.description": "La página que buscas no existe o ha sido movida. Pero no te preocupes, ¡tenemos muchas otras cosas geniales para mostrarte!",
      "notFound.backHome": "Volver al Inicio",
      "notFound.getHelp": "Obtener Ayuda",
      "notFound.tip": "💡 Consejo:",
      "notFound.tipDescription": "Mientras esperamos el lanzamiento de Tenku, puedes unirte a nuestra lista de espera para ser el primero en conectar con tu comunidad deportiva.",

      // Open page
      "open.title": "Abre este contenido en Tenku",
      "open.subtitle": "Escanea el código QR con tu celular para abrir este contenido en la app.",
      "open.scanQR": "Escanea con la cámara de tu celular",
      "open.opening": "Abriendo Tenku...",
      "open.appNotInstalled": "¿No tienes la app?",
      "open.downloadToOpen": "Descarga Tenku para ver este contenido.",
      "open.downloadAppStore": "Descargar en App Store",
      "open.downloadGooglePlay": "Descargar en Google Play",
      "open.tryAgain": "Intentar abrir de nuevo",
      "open.copiedHint": "Guardamos el enlace; te llevará ahí al abrir la app.",

      "invite.title": "Te invitaron a jugar en Tenku",
      "invite.subtitle": "Descarga la app y acepta la invitación.",
      "invite.copiedHint": "Tu invitación quedó copiada; se aplicará al abrir la app.",
      "invite.desktopSubtitle": "Escanea el código QR con tu celular para abrir tu invitación.",
      "venueLink.notFoundTitle": "Este local no existe o ya no está disponible",
      "venueLink.notFoundText": "Revisa el link con quien te lo compartió.",
      "venueLink.errorTitle": "No pudimos cargar el local",
      "venueLink.errorText": "Revisa tu conexión e inténtalo de nuevo.",
      "venueLink.retry": "Reintentar",
      "venueLink.goHome": "Ir a Tenku",
      "venueLink.courts": "Canchas",
      "venueLink.courtCount_one": "{{count}} cancha",
      "venueLink.courtCount_other": "{{count}} canchas",
      "venueLink.courtCountIndoor_one": "{{count}} cancha techada",
      "venueLink.courtCountIndoor_other": "{{count}} canchas techadas",
      "venueLink.indoorCount_one": "{{count}} techada",
      "venueLink.indoorCount_other": "{{count}} techadas",
      "venueLink.priceFrom": "Desde {{price}}",
      "venueLink.amenities": "Servicios",
      "venueLink.amenityParking": "Estacionamiento",
      "venueLink.amenityLockerRooms": "Vestuarios",
      "venueLink.amenityShowers": "Duchas",
      "venueLink.amenityRestrooms": "Baños",
      "venueLink.amenityCafeteria": "Kiosko o cafetería",
      "venueLink.amenityWifi": "Wifi",
      "venueLink.amenityStands": "Tribuna",
      "venueLink.amenityCovered": "Canchas techadas",
      "venueLink.amenityLighting": "Iluminación nocturna",
      "venueLink.amenityWheelchairAccess": "Acceso para silla de ruedas",
      "venueLink.whatsapp": "WhatsApp",
      "venueLink.call": "Llamar",
      "venueLink.website": "Sitio web",
      "venueLink.ctaBook": "Reservar en la app",
      "venueLink.ctaView": "Ver en la app",
      "venueLink.haveApp": "Ya tengo la app",
      "venueLink.valueBook": "Descarga Tenku gratis, mira los horarios libres y envía tu solicitud.",
      "venueLink.iosPasteHint": "Al abrir la app, toca Permitir pegar para ir directo a este local.",
      "venueLink.whatsappMessage": "Hola, los encontré en Tenku. ¿Tienen cancha libre?",
      "venueLink.openInApp": "Abrir en la app Tenku",
      "venueLink.desktopHint": "Escanea el código QR con tu celular para abrir este local en la app Tenku.",
      "venueLink.webOr": "o",
      "venueLink.webBook": "Reservar desde la web",
      "venueLink.webView": "Ver en la web",
      "venueLink.webHint": "Sin descargar nada, desde tu navegador.",
      "venueLink.eventSpaces": "Espacios para eventos",
      "venueLink.eventsWeHost": "Ideal para",
      "venueLink.upToPeople_one": "Hasta {{count}} persona",
      "venueLink.upToPeople_other": "Hasta {{count}} personas",
      "venueLink.includes": "Incluye {{items}}",
      "venueLink.quoteEvent": "Cotizar evento",
      "venueLink.quoteEventSpaceMessage": "Hola, vi {{space}} de {{venue}} en Tenku y quiero cotizar un evento",
      "venueLink.quoteEventMessage": "Hola, vi {{venue}} en Tenku y quiero cotizar un evento",
      "open.continueWeb": "Continuar en la web",
      "open.continueWebHint": "Sin instalar nada, desde el navegador.",

      // Open page - Game preview (sales-oriented)
      "open.preview.hero.subtitle": "Te están esperando en {{venue}}",
      "open.preview.date.today": "Hoy a las {{time}}",
      "open.preview.date.tomorrow": "Mañana a las {{time}}",
      "open.preview.date.thisWeek": "Este {{weekday}} a las {{time}}",
      "open.preview.date.full": "{{date}} a las {{time}}",
      "open.preview.countdown.today": "¡Es hoy!",
      "open.preview.countdown.tomorrow": "Es mañana",
      "open.preview.countdown.days": "Faltan {{count}} días",
      "open.preview.fomo.missingPlayers_one": "Falta 1 de {{total}} jugadores",
      "open.preview.fomo.missingPlayers_other": "Faltan {{count}} de {{total}} jugadores",
      "open.preview.fomo.missingTeams_one": "Falta 1 de {{total}} equipos",
      "open.preview.fomo.missingTeams_other": "Faltan {{count}} de {{total}} equipos",
      "open.preview.fomo.full": "Juego lleno",
      "open.preview.host.organizes": "<s>{{name}}</s> organiza este partido",
      "open.preview.host.beTheFirst": "Sé el primero en anotarte",
      "open.preview.host.playersJoined_one": "+ 1 jugador anotado",
      "open.preview.host.playersJoined_other": "+ {{count}} jugadores anotados",
      "open.preview.host.beTheFirstTeam": "Tu equipo todavía puede sumarse",
      "open.preview.host.teamsConfirmed_one": "1 equipo confirmado",
      "open.preview.host.teamsConfirmed_other": "{{count}} equipos confirmados",
      "open.preview.venue.happeningAt": "Está pasando en",
      "open.preview.venue.openMap": "Ver en el mapa",
      "open.preview.pitch.heading": "Encuentra tu próximo <em>juego</em>",
      "open.preview.pitch.subtitle": "Descubre partidos cerca de ti, organiza tu equipo y conoce deportistas de tu zona.",
      "open.preview.pitch.feature1": "Juegos cerca",
      "open.preview.pitch.feature2": "Tu equipo",
      "open.preview.pitch.feature3": "Tu comunidad",
      "open.preview.cta.joinGame": "Unirme al juego",
      "open.preview.cta.joinWithTeam": "Unirme con mi equipo",
      "open.preview.cta.joinGameSub": "Gratis · iOS y Android",
      "open.preview.cta.alreadyHaveApp": "Ya tengo la app · Abrir",
      "open.preview.cta.linkCopied": "Enlace copiado",
      "open.preview.share.button": "Compartir",
      "open.preview.share.heading": "🏆 ¿Quieres jugar {{sport}}?",
      "open.preview.share.tagline": "Únete a mi juego en Tenku 👇",
      "open.preview.over.finalizedTitle": "Este juego ya pasó",
      "open.preview.over.cancelledTitle": "Este juego fue cancelado",
      "open.preview.over.findMore": "Encuentra más juegos en Tenku. Descarga la app y descubre partidos cerca de ti.",
      "open.preview.notFound.title": "No encontramos este juego",
      "open.preview.notFound.subtitle": "Puede haber sido cancelado o ya no está disponible. Descarga Tenku y explora otros juegos cerca de ti.",
      "open.preview.download.scanQR": "Escanea el QR con tu celular",

      // Common
      "common.privacy": "Privacidad",
      "common.terms": "Términos",
      "common.loading": "Cargando...",

      // Venues (B2B)
      "venues.header.features": "Beneficios",
      "venues.header.how": "Cómo Funciona",
      "venues.header.contact": "Contacto",
      "venues.header.playersApp": "¿Eres jugador?",
      "venues.hero.badge": "Para dueños y administradores de canchas",
      "venues.hero.title": "Gestiona tus canchas",
      "venues.hero.titleHighlight": "sin cuadernos ni caos",
      "venues.hero.subtitle": "Calendario de reservas, control de pagos y base de clientes en un solo lugar. Administra tu cancha desde el celular o la computadora.",
      "venues.hero.ctaPrimary": "Quiero una demo",
      "venues.hero.ctaSecondary": "Ver beneficios",
      "venues.video.title": "Mira cómo funciona en menos de 3 minutos",
      "venues.video.subtitle": "Un recorrido real por el panel: ver horas libres, reservar, confirmar solicitudes y cobrar.",
      "venues.video.play": "Reproducir video",
      "venues.video.duration": "2:39",
      "venues.features.title": "Todo tu Negocio en un Solo Panel",
      "venues.features.subtitle": "Deja atrás el cuaderno y las hojas de cálculo: administra reservas, pagos y clientes sin perder el control de tu día.",
      "venues.features.calendar.title": "Calendario de Reservas",
      "venues.features.calendar.description": "Visualiza la ocupación de cada cancha por día y hora. Registra una reserva en segundos y evita cruces de horarios.",
      "venues.features.spaces.title": "Tus Canchas y Horarios",
      "venues.features.spaces.description": "Configura tus espacios, deportes, horarios de atención y tarifas. Todo se adapta a cómo trabaja tu negocio.",
      "venues.features.payments.title": "Control de Pagos",
      "venues.features.payments.description": "Registra adelantos, saldos y deudas de cada reserva para cuadrar tu caja al final del día.",
      "venues.features.customers.title": "Base de Clientes",
      "venues.features.customers.description": "Identifica a tus clientes frecuentes y consulta su historial de reservas y pagos pendientes.",
      "venues.features.visibility.title": "Visibilidad en la App Tenku",
      "venues.features.visibility.description": "Tu cancha aparece en el mapa donde los jugadores de Tenku organizan sus partidos y buscan dónde jugar.",
      "venues.features.anywhere.title": "Desde Cualquier Dispositivo",
      "venues.features.anywhere.description": "Funciona en la web, sin instalar nada: gestiona desde tu celular, tablet o computadora.",
      "venues.how.title": "Empezar es Simple",
      "venues.how.subtitle": "En tres pasos tu cancha queda funcionando con Tenku.",
      "venues.how.step1.title": "Cuéntanos de tu Cancha",
      "venues.how.step1.description": "Déjanos tus datos y te contactamos para mostrarte el sistema con una demo.",
      "venues.how.step2.title": "Configura tus Espacios",
      "venues.how.step2.description": "Te ayudamos a registrar tus canchas, horarios y tarifas para que quede listo desde el día uno.",
      "venues.how.step3.title": "Gestiona tus Reservas",
      "venues.how.step3.description": "Lleva el calendario, los pagos y tus clientes al día desde un solo panel.",
      "venues.contact.title": "Hablemos de tu Cancha",
      "venues.contact.subtitle": "Déjanos tus datos y te contactamos para coordinar una demo sin compromiso.",
      "venues.contact.name": "Tu nombre",
      "venues.contact.namePlaceholder": "Nombre y apellido",
      "venues.contact.venueName": "Nombre de tu cancha o complejo",
      "venues.contact.venueNamePlaceholder": "Ej. Complejo Deportivo San Martín",
      "venues.contact.city": "Ciudad",
      "venues.contact.cityPlaceholder": "Ej. Trujillo",
      "venues.contact.phone": "Teléfono / WhatsApp",
      "venues.contact.phonePlaceholder": "Ej. 999 999 999",
      "venues.contact.email": "Email (opcional)",
      "venues.contact.emailPlaceholder": "tucorreo@ejemplo.com",
      "venues.contact.message": "Cuéntanos algo más (opcional)",
      "venues.contact.messagePlaceholder": "¿Cuántas canchas tienes? ¿Qué deportes?",
      "venues.contact.submit": "Enviar",
      "venues.contact.sending": "Enviando...",
      "venues.contact.success": "¡Gracias! Te contactaremos muy pronto.",
      "venues.contact.error": "No pudimos enviar el formulario. Inténtalo de nuevo o escríbenos a support@tenkusports.com.",
      "venues.contact.privacy": "Solo usaremos tus datos para contactarte. Nada de spam.",
      "venues.header.pricing": "Precios",
      "audience.label": "Tenku para",
      "audience.players": "Jugadores",
      "audience.venues": "Canchas",
      "venues.header.login": "Entrar al panel",
      "venuesBand.eyebrow": "Para dueños de canchas",
      "venuesBand.title": "¿Tienes canchas? Gestiónalas con Tenku",
      "venuesBand.text": "Reservas, cobros y clientes en un solo lugar, desde el celular o la computadora. Y los jugadores de Tenku pueden encontrarte y reservar en línea.",
      "venuesBand.cta": "Conoce Tenku para canchas",
      "venuesBand.login": "Entrar al panel",
      "venues.pricing.title": "Un Plan para Cada Cancha",
      "venues.pricing.subtitle": "Empieza gratis y crece a tu ritmo. Todos los precios son por sede, con canchas ilimitadas.",
      "venues.pricing.billing": "Facturación",
      "venues.pricing.monthly": "Mensual",
      "venues.pricing.yearly": "Anual",
      "venues.pricing.yearlySave": "2 meses gratis",
      "venues.pricing.recommended": "Recomendado",
      "venues.pricing.comingSoon": "Próximamente",
      "venues.pricing.perMonth": "/mes",
      "venues.pricing.billedYearly": "{{amount}} facturado al año, por sede",
      "venues.pricing.perBranch": "Por sede, canchas ilimitadas",
      "venues.pricing.freeForever": "Gratis para siempre",
      "venues.pricing.ctaFree": "Crear cuenta gratis",
      "venues.pricing.ctaTrial": "Probar 2 meses gratis",
      "venues.pricing.ctaStart": "Empezar ahora",
      "venues.pricing.factTrial": "Al registrarte tienes 2 meses de Pro gratis, sin tarjeta.",
      "venues.pricing.factData": "Si cambias de plan, tus datos se conservan.",
      "venues.pricing.factPayment": "Paga por transferencia bancaria.",
      "venues.pricing.demoQuestion": "¿Prefieres que te lo mostremos primero?",
      "venues.pricing.demoLink": "Pide una demo",
      "venues.pricing.free.name": "Free",
      "venues.pricing.free.tagline": "Aparece en Tenku y deja el cuaderno.",
      "venues.pricing.free.f1": "Local verificado en la app Tenku",
      "venues.pricing.free.f2": "Botón para que los jugadores te escriban por WhatsApp o te llamen",
      "venues.pricing.free.f3": "Reservas manuales en la lista del día",
      "venues.pricing.free.f4": "Bloqueos de horario",
      "venues.pricing.free.f5": "Resumen del día",
      "venues.pricing.free.f6": "1 publicación al mes en el feed de Tenku (próximamente)",
      "venues.pricing.starter.name": "Starter",
      "venues.pricing.starter.tagline": "Digitaliza tu cancha y recibe reservas desde la app.",
      "venues.pricing.starter.includes": "Todo lo de Free, más:",
      "venues.pricing.starter.f1": "Reservas desde la app Tenku",
      "venues.pricing.starter.f2": "Notificaciones de nuevas reservas",
      "venues.pricing.starter.f3": "Notificaciones a tus clientes de la app",
      "venues.pricing.starter.f4": "Calendario semanal de todas tus canchas",
      "venues.pricing.starter.f5": "Reservas por confirmar con plazo",
      "venues.pricing.starter.f6": "Hora fija: reservas que se repiten cada semana",
      "venues.pricing.starter.f7": "Comprobantes de pago en cada reserva",
      "venues.pricing.starter.f8": "Hasta 2 usuarios de Personal",
      "venues.pricing.starter.f9": "Reportes hasta el mes, comparados con el periodo anterior",
      "venues.pricing.starter.f10": "Lo que te trajo Tenku: reservas y cobros desde la app",
      "venues.pricing.starter.f11": "4 publicaciones al mes en el feed (próximamente)",
      "venues.pricing.pro.name": "Pro",
      "venues.pricing.pro.tagline": "Opera tu local completo desde un solo panel.",
      "venues.pricing.pro.includes": "Todo lo de Starter, más:",
      "venues.pricing.pro.f1": "Tienda: productos, stock, ventas y cierre de caja",
      "venues.pricing.pro.f2": "Eventos: reserva tus canchas y espacios para cumpleaños, empresas y más",
      "venues.pricing.pro.f3": "Clientes: quién vuelve y quién dejó de venir",
      "venues.pricing.pro.f4": "Promociones de fidelidad: cada N horas jugadas, un premio",
      "venues.pricing.pro.f5": "Personal ilimitado",
      "venues.pricing.pro.f6": "Reportes completos: ocupación por día y hora y horas sin vender",
      "venues.pricing.pro.f7": "Oportunidades: franjas flojas y clientes para ofrecer hora fija",
      "venues.pricing.pro.f8": "Saldos por cobrar y lo que perdiste en no-shows y cancelaciones",
      "venues.pricing.pro.f9": "Exportación a CSV",
      "venues.pricing.pro.f10": "Publicaciones ilimitadas en el feed (próximamente)",
      "venues.pricing.growth.name": "Growth",
      "venues.pricing.growth.tagline": "Llena tus horas y haz crecer tu negocio.",
      "venues.pricing.growth.includes": "Todo lo de Pro, más:",
      "venues.pricing.growth.f1": "Destacado en el feed de Tenku",
      "venues.pricing.growth.f2": "Prioridad en las búsquedas de la app",
      "venues.pricing.growth.f3": "Horas con descuento para llenar las horas de baja demanda",

      "sim.docTitle": "Simulador de cuadros | Tenku",
      "sim.title": "Simulador de cuadros",
      "sim.subtitle": "Arma tu torneo eliminatorio antes de reservar la cancha: elige equipos, formato y disponibilidad, y mira cuántos partidos salen y a qué hora termina todo.",
      "sim.tournament": "Torneo",
      "sim.teams": "Equipos",
      "sim.formatByes": "Cuadro con byes",
      "sim.formatLL": "Repechaje",
      "sim.matchMin": "Partido (min)",
      "sim.restMin": "Tiempo entre partidos en cancha (min)",
      "sim.teamRestMin": "Descanso mínimo por equipo (min)",
      "sim.thirdPlace": "Partido por el 3er puesto",
      "sim.ceremony": "Premiación al cierre",
      "sim.ceremonyMin": "Premiación (min)",
      "sim.courtsTitle": "Canchas y disponibilidad",
      "sim.court": "Cancha",
      "sim.addCourt": "+ Agregar cancha",
      "sim.removeCourt": "Quitar cancha",
      "sim.from": "de",
      "sim.to": "a",
      "sim.hintByes": "Cuadro de {{target}}; equipos con bye (pasan directo): {{byes}}; llaves de primera ronda: {{played}}.",
      "sim.hintByesNone": "Cuadro de {{target}}: sin byes, todos juegan la primera ronda.",
      "sim.hintLL": "Con {{n}} equipos se juega a cuadro de {{target}} (equipos con bye en la Ronda 1: {{byes}}) y el mejor perdedor de la última ronda previa revive para completar {{phase}}.",
      "sim.hintLLNoByes": "Con {{n}} equipos se juega a cuadro de {{target}}: todos juegan desde la Ronda 1 y el mejor perdedor de la última ronda previa revive para completar {{phase}}.",
      "sim.hintLLResolved": "Con {{n}} equipos el repechaje resuelve al cuadro normal (el relleno cae en potencia de 2: cuadro de {{target}}).",
      "sim.phaseSemis": "las semifinales",
      "sim.phaseQuarters": "los cuartos de final",
      "sim.phaseR16": "los octavos de final",
      "sim.phaseR32": "los dieciseisavos de final",
      "sim.matches": "Partidos",
      "sim.rounds": "Rondas",
      "sim.endsAt": "Todo termina",
      "sim.playTime": "Tiempo de juego",
      "sim.warnNoFit": "No caben {{count}} partidos ({{list}}) en la disponibilidad actual. Amplía la ventana de alguna cancha unos {{min}} min, agrega una cancha o acorta los partidos.",
      "sim.schedTitle": "Cronograma por cancha",
      "sim.bracketTitle": "Estructura del cuadro",
      "sim.noMatches": "sin partidos asignados",
      "sim.ceremonyLabel": "Premiación",
      "sim.thirdShort": "3er puesto",
      "sim.semiLosers": "Perdedores de semifinales",
      "sim.repechageNote": "Al cerrar la {{round}}, el organizador confirma en la app al mejor perdedor que revive (margen de derrota, luego puntos, luego sorteo).",
      "sim.byeAdvances": "{{team}} pasa directo",
      "sim.winnerOf": "Ganador {{id}}",
      "sim.prelimWinner": "Ganador {{n}} de la ronda previa",
      "sim.luckyLoser": "Mejor perdedor",
      "sim.llBadge": "REP",
      "sim.roundN": "Ronda {{n}}",
      "sim.r64": "Treintaidosavos",
      "sim.r32": "Dieciseisavos",
      "sim.r16": "Octavos",
      "sim.qf": "Cuartos",
      "sim.sf": "Semifinales",
      "sim.final": "Final",
      "sim.matchOne": "1 partido",
      "sim.matchMany": "{{count}} partidos",
      "sim.ctaTitle": "¿Te cuadra? Créalo en Tenku",
      "sim.ctaSubtitle": "Crea el torneo en la app: sorteo automático, fixture, resultados y tabla en vivo para todos los equipos.",
      "sim.ctaButton": "Crear mi torneo en Tenku",
      "sim.ctaStores": "Gratis en App Store y Google Play",
      "sim.footNote": "Simulación con las mismas reglas de generación de Tenku; el sorteo en la app define qué equipo cae en cada llave.",

      // Refer
      "refer.pageTitle": "Recomienda un local y gana S/ 200 | Tenku",
      "refer.hero.badge": "Solo en Perú",
      "refer.hero.title": "Recomienda un local y gana",
      "refer.hero.titleHighlight": "S/ 200",
      "refer.hero.subtitle": "¿Juegas en un local que todavía no usa Tenku? Convéncelo de registrarse y gana S/ 200 cuando empiece a usar un plan pagado.",
      "refer.hero.ctaTerms": "Ver términos",
      "refer.how.title": "Cómo funciona",
      "refer.how.step1.title": "Habla con tu local",
      "refer.how.step1.description": "Pídele al local donde juegas que se registre en Tenku para que puedas reservar desde la app. Te damos el mensaje listo para mandarlo por WhatsApp.",
      "refer.how.step2.title": "El local se registra",
      "refer.how.step2.description": "Cuando se registre, avísanos con el nombre del local y tu usuario. Confirmamos con el dueño que tú lo recomendaste.",
      "refer.how.step3.title": "Cobras S/ 200",
      "refer.how.step3.description": "Cuando el local completa 3 meses pagados o contrata un plan anual, te pagamos por Yape o transferencia.",
      "refer.terms.title": "Términos y condiciones",
      "refer.terms.who.title": "Quién participa",
      "refer.terms.who.body": "Usuarios de Tenku mayores de 18 años con residencia en Perú.",
      "refer.terms.venues.title": "Qué locales cuentan",
      "refer.terms.venues.body": "Locales deportivos en Perú que no tengan cuenta en Tenku al momento de la recomendación.",
      "refer.terms.how.title": "Cómo se recomienda",
      "refer.terms.how.body": "Pídele al local que se registre en Tenku y escríbenos a support@tenkusports.com con el nombre del local y tu usuario. Tenku confirma con el dueño quién lo recomendó.",
      "refer.terms.when.title": "Cuándo se gana",
      "refer.terms.when.body": "Ganas S/ 200 cuando el local recomendado completa 3 meses pagados de cualquier plan, o cuando contrata un plan anual. El uso gratuito no cuenta para los 3 meses.",
      "refer.terms.once.title": "Un premio por local",
      "refer.terms.once.body": "Se paga una sola vez por local, aunque tenga varias sedes. Si dos personas recomiendan el mismo local, el premio es para la primera que lo reportó.",
      "refer.terms.payment.title": "Cómo se paga",
      "refer.terms.payment.body": "Por Yape o transferencia bancaria, dentro de los 15 días siguientes a cumplirse la condición.",
      "refer.terms.changes.title": "Cambios",
      "refer.terms.changes.body": "Tenku puede cambiar o terminar esta promoción en cualquier momento. Las recomendaciones registradas antes del cambio mantienen las condiciones con las que se hicieron.",
      "refer.share.cta": "Compartir con el local",
      "refer.share.message": "Hola, juego en tu local y me gustaría reservar desde Tenku. Es una app para reservar canchas y organizar partidos y torneos, y a ti te ordena las reservas. Puedes empezar gratis: https://tenkusports.com/venues",
      "refer.report.title": "¿Ya se registró tu local?",
      "refer.report.description": "Escríbenos con el nombre del local y tu usuario para dejar registrada tu recomendación.",
      "refer.report.cta": "Avisar a Tenku",
      "refer.emailNote": "También puedes escribirnos directamente a",
      "refer.mail.subject": "Convencí a un local",
      "refer.mail.body": "Nombre del local:\nDistrito:\n\nMi nombre:\nMi usuario en Tenku:\nMi celular:\n",
    }
  },
  en: {
    translation: {
      // Header
      "header.home": "Home",
      "header.features": "Features",
      "header.howItWorks": "How It Works",
      "header.testimonials": "Problems",
      "header.faq": "FAQ",
      "header.signup": "Join",
      "header.backToTenku": "Back to Tenku",
      "header.openWeb": "Open the web app",

      // Hero
      "hero.title": "Connect with your",
      "hero.titleHighlight": "Sports Community",
      "hero.subtitle": "Discover games near you, organize teams and tournaments, and connect with other athletes. Your next game is just a tap away.",
      "hero.ctaPrimary": "Download Now",
      "hero.ctaSecondary": "Learn More",
      "hero.ctaWeb": "Use in the browser",
      "hero.nowAvailable": "Available Now!",
      "hero.downloadSubtitle": "Download the app on iOS or Android, or use it from your browser, and connect with your sports community today.",
      "hero.badge": "Available on iOS, Android & web",
      "hero.cardGame.title": "Pickup 7v7",
      "hero.cardGame.meta": "8/14 players · Today 8:00 PM",
      "hero.cardNear.title": "Near you",
      "hero.cardNear.meta": "0.7 mi away · 5 open games",

      // Features
      "features.title": "Everything You Need to Play",
      "features.subtitle": "Tenku gives you all the tools to connect with other athletes, organize games and grow your passion for sports.",
      "features.findGames.title": "Find Games Nearby",
      "features.findGames.description": "Use our interactive map to discover games and sports events in your area instantly.",
      "features.organizeTeams.title": "Organize Your Teams",
      "features.organizeTeams.description": "Create team profiles, invite players and manage your roster easily.",
      "features.tournaments.title": "Organize Tournaments",
      "features.tournaments.description": "Create your tournament, invite teams and manage the fixture, results and standings from the app.",
      "features.lineups.title": "Formations and Lineups",
      "features.lineups.description": "Build your team's lineup on the field, assign positions and share it before every game.",
      "features.arrival.title": "Follow the Game Live",
      "features.arrival.description": "Check in with one tap and see in real time who's already at the field, even from your lock screen.",
      "features.chat.title": "Built-in Chat",
      "features.chat.description": "Every game and team has its own chat: coordinate everything in one place, without endless message threads.",
      "features.playerSearch.title": "Find Players",
      "features.playerSearch.description": "Search athletes by sport, check their profile and connect for your next game.",
      "features.notifications.title": "Real-time Notifications",
      "features.notifications.description": "Get alerts about new games, team invitations and messages from other players.",
      "features.personalStats.title": "Personal Statistics",
      "features.personalStats.description": "Keep track of your games, improve your performance and share your achievements with the community.",
      "features.booking.title": "Book Your Court",
      "features.booking.description": "Open your venue's link, pick a free time slot and send your booking from the app. The venue confirms it and you track its status in My bookings.",

      // How It Works
      "howItWorks.title": "How Does It Work?",
      "howItWorks.subtitle": "In just three simple steps you'll be connected with your city's sports community.",
      "howItWorks.step1.title": "Create Your Profile",
      "howItWorks.step1.description": "Sign up and complete your sports profile with your favorite sports and skill level.",
      "howItWorks.step2.title": "Find or Create Games",
      "howItWorks.step2.description": "Explore games near you or create your own for others to join.",
      "howItWorks.step3.title": "Connect and Play",
      "howItWorks.step3.description": "Join games, meet new athletes and enjoy playing your favorite sport.",

      // Testimonials
      "testimonials.title": "Does This Sound Familiar?",
      "testimonials.subtitle": "These are the most common problems athletes face today.",
      "testimonials.subtitleHighlight": " Tenku solves them all.",
      "testimonials.problem1.title": "Incomplete Teams",
      "testimonials.problem1.description": "Someone's always missing. You organize a soccer game and only 6 people show up. Impossible to play!",
      "testimonials.problem2.title": "No Playing Partners",
      "testimonials.problem2.description": "I want to play tennis but my friends are always busy. I end up training alone again.",
      "testimonials.problem3.title": "Impossible Coordination",
      "testimonials.problem3.description": "WhatsApp full of messages to organize ONE game. Nobody agrees on the schedule.",
      "testimonials.problem4.title": "Empty Courts",
      "testimonials.problem4.description": "I arrive at the court and nobody's playing. I would have liked to join some group.",
      "testimonials.problem5.title": "Limited Schedules",
      "testimonials.problem5.description": "I can only play certain days but my usual group doesn't match. My free time is wasted.",
      "testimonials.problem6.title": "New City",
      "testimonials.problem6.description": "I moved and don't know anyone who plays my favorite sport. How do I find people here?",

      // Downloads
      "downloads.title": "Download Tenku Now!",
      "downloads.subtitle": "The app is available on iOS and Android, and you can also use it from your browser with nothing to install. Join our community of athletes today!",
      "downloads.downloadOn": "Get it on",
      "downloads.appStore": "App Store",
      "downloads.googlePlay": "Google Play",
      "downloads.appStoreLink": "https://apps.apple.com/pe/app/sports-nest/id6753092450",
      "downloads.googlePlayLink": "https://play.google.com/store/apps/details?id=com.jabanto.sportsnest",
      "downloads.availableNow": "✅ The app is now available on both platforms",
      "downloads.scanQr": "Scan the code with your phone's camera to download the app.",
      "downloads.webLabel": "No install",
      "downloads.webName": "Web version",
      "downloads.webLink": "https://app.tenkusports.com",
      "downloads.webNote": "Ideal if your phone is not compatible with the app or if you run tournaments from a laptop.",
      "downloads.betaNotice": "📱 Available now on iOS and Android",

      // FAQ
      "faq.title": "Frequently Asked Questions",
      "faq.subtitle": "We answer the most common questions about Tenku.",
      "faq.q1.question": "Can I join a game if I'm a beginner?",
      "faq.q1.answer": "Absolutely! In Tenku you can filter games by skill level. There's a welcoming community for everyone, from beginners to advanced players.",
      "faq.q2.question": "How does team creation work?",
      "faq.q2.answer": "You can create your team's profile, invite players with a link, manage your roster and build the lineup for every game.",
      "faq.q3.question": "Is it safe to meet people through the app?",
      "faq.q3.answer": "Safety is our priority. We have verified profiles, a player rating system and we recommend always playing in public and known places.",
      "faq.q4.question": "Will Tenku be available in my city?",
      "faq.q4.answer": "Tenku will work in any city from day one. Each place's sports community will grow organically: the more users invite their friends, the more active the local network will be. Be the pioneer in your city!",
      "faq.q5.question": "Can I organize a tournament in Tenku?",
      "faq.q5.answer": "Yes. Create your tournament, invite teams and manage the fixture, results and standings right from the app.",
      "faq.q6.question": "Is the app free?",
      "faq.q6.answer": "Yes, Tenku is free. You can find games, create teams and organize tournaments at no cost.",
      "faq.q7.question": "Is my phone not compatible with the app?",
      "faq.q7.answer": "You can use Tenku from your browser at app.tenkusports.com with the same account: find games and tournaments, register your team, accept invitations and run your tournaments. Chat and a few features stay in the app only.",

      // Footer
      "footer.description": "Connecting athletes and building sports communities worldwide. Your next game is just a tap away.",
      "footer.copyright": "© {{year}} Tenku. All rights reserved.",
      "footer.product": "Product",
      "footer.legal": "Legal",
      "footer.tagline": "Play without excuses",
      "footer.forVenues": "Do you manage a sports venue?",
      "footer.forPlayers": "Are you a player? Get the app",
      "footer.descriptionVenues": "Bookings, payments and customers for your venue in one place, plus players who find you on Tenku.",
      "footer.webApp": "Use Tenku in the browser",

      // Legal pages
      "legal.privacyTitle": "Privacy Policy",
      "legal.termsTitle": "Terms and Conditions",
      "legal.lastUpdated": "Last updated:",

      // Privacy Policy
      "privacy.section1.title": "1. Information We Collect",
      "privacy.section1.intro": "At Tenku, we collect the following information to provide you with a better experience:",
      "privacy.section1.accountInfo": "Account information: name, email, age, profile photo",
      "privacy.section1.sportsInfo": "Sports information: favorite sports, skill level, availability",
      "privacy.section1.locationInfo": "Location information: approximate location to show you games near you (only when using the app)",
      "privacy.section1.commInfo": "Communication data: messages with other users, invitations",
      "privacy.section1.usageInfo": "Usage data: how you interact with the app, preferences, game statistics",
      "privacy.section1.deviceInfo": "Device information: unique identifier, operating system, device type",
      "privacy.section1.authInfo": "Authentication data: Apple ID, Google, Facebook information if you use social login",

      "privacy.section2.title": "2. How We Use Your Information",
      "privacy.section2.intro": "We use your information to:",
      "privacy.section2.connect": "Connect you with other athletes in your area",
      "privacy.section2.showGames": "Show you relevant games and events",
      "privacy.section2.notifications": "Send notifications about invitations and updates",
      "privacy.section2.security": "Improve the security and functionality of the application",
      "privacy.section2.support": "Provide technical support when you need it",

      "privacy.section3.title": "3. Information Sharing",
      "privacy.section3.intro": "We do not sell or rent your personal information. We share limited information only when:",
      "privacy.section3.necessary": "It is necessary to connect you with other users of the application",
      "privacy.section3.legal": "Required by law or competent authorities",
      "privacy.section3.safety": "It is necessary to protect the safety of our users",

      "privacy.section4.title": "4. Data Security",
      "privacy.section4.intro": "We implement technical and organizational security measures to protect your personal information:",
      "privacy.section4.encryption": "Data encryption in transit and at rest",
      "privacy.section4.auth": "Secure authentication and access tokens",
      "privacy.section4.servers": "Secure servers with limited access",
      "privacy.section4.monitoring": "Continuous security monitoring",
      "privacy.section4.compliance": "Compliance with industry standards",

      "privacy.section5.title": "5. Data Retention",
      "privacy.section5.intro": "We retain your personal information only as long as necessary to:",
      "privacy.section5.services": "Provide our services",
      "privacy.section5.legal": "Comply with legal obligations",
      "privacy.section5.disputes": "Resolve disputes",
      "privacy.section5.deletion": "If you delete your account, we will delete your information within 30 days",

      "privacy.section6.title": "6. International Transfers",
      "privacy.section6.content": "Your data may be processed on servers located outside your country of residence. We guarantee the same level of protection through appropriate data transfer agreements.",

      "privacy.section7.title": "7. Minors",
      "privacy.section7.content": "Tenku is not directed at children under 13 years of age. We do not intentionally collect personal information from children under 13. If we discover that we have collected information from a child under 13, we will delete it immediately.",

      "privacy.section8.title": "8. Your Rights",
      "privacy.section8.intro": "You have the right to:",
      "privacy.section8.access": "Access your personal information",
      "privacy.section8.correct": "Correct incorrect information",
      "privacy.section8.delete": "Delete your account and data",
      "privacy.section8.portability": "Data portability",
      "privacy.section8.object": "Object to the processing of your data",

      "privacy.section9.title": "9. Changes to This Policy",
      "privacy.section9.content": "We may update this privacy policy occasionally. We will notify you of significant changes through the application or by email. Your continued use of Tenku after the changes constitutes your acceptance of the new policy.",

      "privacy.section10.title": "10. Contact",
      "privacy.section10.content": "If you have questions about this privacy policy, contact us at:",
      "privacy.section10.email": "Email: privacy@tenkusports.com",

      // Terms
      "terms.section1.title": "1. Acceptance of Terms",
      "terms.section1.content": "By accessing and using Tenku, you agree to be legally bound by these terms and conditions. If you do not agree with any of these terms, do not use our services.",

      "terms.section2.title": "2. Service Description",
      "terms.section2.intro": "Tenku is a platform that connects athletes and sports enthusiasts to:",
      "terms.section2.find": "Find and join local sports games",
      "terms.section2.organize": "Organize teams and sports events",
      "terms.section2.connect": "Connect with other athletes in your area",
      "terms.section2.participate": "Participate in tournaments and competitions",

      "terms.section3.title": "3. User Registration and Account",
      "terms.section3.intro": "To use Tenku, you must:",
      "terms.section3.age": "Be over 13 years old (minors need parental consent)",
      "terms.section3.accurate": "Provide accurate and updated information",
      "terms.section3.security": "Maintain the security of your account and password",
      "terms.section3.notify": "Immediately notify any unauthorized use",

      "terms.section4.title": "4. User Conduct",
      "terms.section4.intro": "By using Tenku, you commit to:",
      "terms.section4.respectful": "Behave respectfully with other users",
      "terms.section4.noOffensive": "Not post offensive, discriminatory, violent or inappropriate content",
      "terms.section4.noIllegal": "Not use the platform for illegal or fraudulent activities",
      "terms.section4.noHarass": "Not harass, intimidate or threaten other users",
      "terms.section4.noFake": "Not create fake accounts or impersonate other people",
      "terms.section4.noSpam": "Not send spam or unsolicited promotional content",
      "terms.section4.ip": "Respect third-party intellectual property",
      "terms.section4.noInterfere": "Not interfere with the operation of the application",
      "terms.section4.rules": "Comply with the specific rules of each sports event",

      "terms.section5.title": "5. Safety and Responsibility",
      "terms.section5.important": "Important:",
      "terms.section5.intro": "Participation in sports activities carries inherent risks. By using Tenku:",
      "terms.section5.ownRisk": "You participate at your own risk",
      "terms.section5.insurance": "You must have appropriate medical insurance",
      "terms.section5.notResponsible": "Tenku is not responsible for injuries or damages",
      "terms.section5.recommend": "We recommend meeting other users in public places",

      "terms.section6.title": "6. User Content",
      "terms.section6.content": "By posting content on Tenku (photos, messages, etc.), you grant Tenku a limited license to display that content within the application. You retain all rights to your content and can delete it at any time.",

      "terms.section7.title": "7. Intellectual Property",
      "terms.section7.content": "Tenku and all its content (design, code, logos, texts) are owned by the company and are protected by intellectual property laws. You may not copy, modify or distribute any application content without express authorization.",

      "terms.section8.title": "8. Payments and Subscriptions",
      "terms.section8.content": "Tenku offers free basic features and paid premium features. Payments are processed through Apple App Store or Google Play Store. Refund policies are subject to the terms of these platforms.",

      "terms.section9.title": "9. Limitation of Liability",
      "terms.section9.content": "Tenku is provided \"as is\". We do not guarantee that the service will be uninterrupted or error-free. Our liability is limited to the maximum permitted by law.",

      "terms.section10.title": "10. Applicable Law and Jurisdiction",
      "terms.section10.content": "These terms are governed by the laws of the country where Tenku operates. Any dispute will be resolved through arbitration or in the competent courts of said jurisdiction.",

      "terms.section11.title": "11. Modifications",
      "terms.section11.content": "We reserve the right to modify these terms at any time. Significant changes will be notified through the application.",

      "terms.section12.title": "12. Termination",
      "terms.section12.content": "We may terminate or suspend your account at any time for violation of these terms. You can also delete your account at any time from the application settings.",

      "terms.section13.title": "13. Contact",
      "terms.section13.content": "If you have questions about these terms, contact us at:",
      "terms.section13.email": "Email: legal@tenkusports.com",

      // Support
      "support.title": "Support",
      "support.subtitle": "We're here to help you with any questions about Tenku.",
      "support.deleteAccount.title": "Account Deletion",
      "support.deleteAccount.description": "If you wish to permanently delete your Tenku account and all associated data, you can request it by following these steps:",
      "support.deleteAccount.steps.title": "Steps to delete your account:",
      "support.deleteAccount.steps.step1": "Send an email to support@tenkusports.com",
      "support.deleteAccount.steps.step2": "Include in the subject: 'Account deletion request'",
      "support.deleteAccount.steps.step3": "Provide your registered email and confirm that you want to permanently delete your account",
      "support.deleteAccount.thirdParty.title": "Third-party linked accounts",
      "support.deleteAccount.thirdParty.description": "If you signed up using third-party services, we will also process the unlinking automatically:",
      "support.deleteAccount.thirdParty.google": "Will be automatically unlinked from your Google account",
      "support.deleteAccount.thirdParty.facebook": "Will be automatically unlinked from your Facebook account",
      "support.deleteAccount.warning.title": "Important",
      "support.deleteAccount.warning.description": "This action is irreversible. All your data, games, connections and profile information will be permanently deleted.",
      "support.contactButton": "Contact Support",

      // 404 Page
      "notFound.title": "Oops! Page not found",
      "notFound.subtitle": "Looks like this page went to play on another field",
      "notFound.description": "The page you're looking for doesn't exist or has been moved. But don't worry, we have many other great things to show you!",
      "notFound.backHome": "Back to Home",
      "notFound.getHelp": "Get Help",
      "notFound.tip": "💡 Tip:",
      "notFound.tipDescription": "While we wait for the Tenku launch, you can join our waiting list to be the first to connect with your sports community.",

      // Open page
      "open.title": "Open this content in Tenku",
      "open.subtitle": "Scan the QR code with your phone to open this content in the app.",
      "open.scanQR": "Scan with your phone's camera",
      "open.opening": "Opening Tenku...",
      "open.appNotInstalled": "Don't have the app?",
      "open.downloadToOpen": "Download Tenku to view this content.",
      "open.downloadAppStore": "Download on App Store",
      "open.downloadGooglePlay": "Download on Google Play",
      "open.tryAgain": "Try opening again",
      "open.copiedHint": "We saved the link; it will take you there when you open the app.",

      "invite.title": "You've been invited to play on Tenku",
      "invite.subtitle": "Download the app and accept the invitation.",
      "invite.copiedHint": "Your invite was copied; it will apply when you open the app.",
      "invite.desktopSubtitle": "Scan the QR code with your phone to open your invitation.",
      "venueLink.notFoundTitle": "This venue does not exist or is no longer available",
      "venueLink.notFoundText": "Check the link with whoever shared it with you.",
      "venueLink.errorTitle": "We could not load the venue",
      "venueLink.errorText": "Check your connection and try again.",
      "venueLink.retry": "Try again",
      "venueLink.goHome": "Go to Tenku",
      "venueLink.courts": "Courts",
      "venueLink.courtCount_one": "{{count}} court",
      "venueLink.courtCount_other": "{{count}} courts",
      "venueLink.courtCountIndoor_one": "{{count}} indoor court",
      "venueLink.courtCountIndoor_other": "{{count}} indoor courts",
      "venueLink.indoorCount_one": "{{count}} indoor",
      "venueLink.indoorCount_other": "{{count}} indoor",
      "venueLink.priceFrom": "From {{price}}",
      "venueLink.amenities": "Amenities",
      "venueLink.amenityParking": "Parking",
      "venueLink.amenityLockerRooms": "Locker rooms",
      "venueLink.amenityShowers": "Showers",
      "venueLink.amenityRestrooms": "Restrooms",
      "venueLink.amenityCafeteria": "Snack bar",
      "venueLink.amenityWifi": "Wi-Fi",
      "venueLink.amenityStands": "Stands",
      "venueLink.amenityCovered": "Covered courts",
      "venueLink.amenityLighting": "Night lighting",
      "venueLink.amenityWheelchairAccess": "Wheelchair access",
      "venueLink.whatsapp": "WhatsApp",
      "venueLink.call": "Call",
      "venueLink.website": "Website",
      "venueLink.ctaBook": "Book in the app",
      "venueLink.ctaView": "View in the app",
      "venueLink.haveApp": "I already have the app",
      "venueLink.valueBook": "Download Tenku for free, check the free slots and send your request.",
      "venueLink.iosPasteHint": "When you open the app, tap Allow Paste to go straight to this venue.",
      "venueLink.whatsappMessage": "Hi, I found you on Tenku. Do you have a free court?",
      "venueLink.openInApp": "Open in the Tenku app",
      "venueLink.desktopHint": "Scan the QR code with your phone to open this venue in the Tenku app.",
      "venueLink.webOr": "or",
      "venueLink.webBook": "Book on the web",
      "venueLink.webView": "View on the web",
      "venueLink.webHint": "No download needed, right from your browser.",
      "venueLink.eventSpaces": "Event spaces",
      "venueLink.eventsWeHost": "Ideal for",
      "venueLink.upToPeople_one": "Up to {{count}} person",
      "venueLink.upToPeople_other": "Up to {{count}} people",
      "venueLink.includes": "Includes {{items}}",
      "venueLink.quoteEvent": "Get an event quote",
      "venueLink.quoteEventSpaceMessage": "Hi, I saw {{space}} at {{venue}} on Tenku and would like a quote for an event",
      "venueLink.quoteEventMessage": "Hi, I saw {{venue}} on Tenku and would like a quote for an event",
      "open.continueWeb": "Continue on the web",
      "open.continueWebHint": "No install needed, right from the browser.",

      // Open page - Game preview (sales-oriented)
      "open.preview.hero.subtitle": "They're waiting for you at {{venue}}",
      "open.preview.date.today": "Today at {{time}}",
      "open.preview.date.tomorrow": "Tomorrow at {{time}}",
      "open.preview.date.thisWeek": "This {{weekday}} at {{time}}",
      "open.preview.date.full": "{{date}} at {{time}}",
      "open.preview.countdown.today": "It's today!",
      "open.preview.countdown.tomorrow": "It's tomorrow",
      "open.preview.countdown.days": "In {{count}} days",
      "open.preview.fomo.missingPlayers_one": "1 of {{total}} players still needed",
      "open.preview.fomo.missingPlayers_other": "{{count}} of {{total}} players still needed",
      "open.preview.fomo.missingTeams_one": "1 of {{total}} teams still needed",
      "open.preview.fomo.missingTeams_other": "{{count}} of {{total}} teams still needed",
      "open.preview.fomo.full": "Game is full",
      "open.preview.host.organizes": "<s>{{name}}</s> is hosting this game",
      "open.preview.host.beTheFirst": "Be the first to join",
      "open.preview.host.playersJoined_one": "+ 1 player signed up",
      "open.preview.host.playersJoined_other": "+ {{count}} players signed up",
      "open.preview.host.beTheFirstTeam": "Your team can still join",
      "open.preview.host.teamsConfirmed_one": "1 team confirmed",
      "open.preview.host.teamsConfirmed_other": "{{count}} teams confirmed",
      "open.preview.venue.happeningAt": "Happening at",
      "open.preview.venue.openMap": "View on map",
      "open.preview.pitch.heading": "Find your next <em>game</em>",
      "open.preview.pitch.subtitle": "Discover games near you, build your team, and meet athletes in your area.",
      "open.preview.pitch.feature1": "Games nearby",
      "open.preview.pitch.feature2": "Your team",
      "open.preview.pitch.feature3": "Your community",
      "open.preview.cta.joinGame": "Join this game",
      "open.preview.cta.joinWithTeam": "Join with my team",
      "open.preview.cta.joinGameSub": "Free · iOS and Android",
      "open.preview.cta.alreadyHaveApp": "Already have the app · Open",
      "open.preview.cta.linkCopied": "Link copied",
      "open.preview.share.button": "Share",
      "open.preview.share.heading": "🏆 Want to play {{sport}}?",
      "open.preview.share.tagline": "Join my game on Tenku 👇",
      "open.preview.over.finalizedTitle": "This game already happened",
      "open.preview.over.cancelledTitle": "This game was cancelled",
      "open.preview.over.findMore": "Find more games on Tenku. Download the app and discover games near you.",
      "open.preview.notFound.title": "We couldn't find this game",
      "open.preview.notFound.subtitle": "It may have been cancelled or is no longer available. Download Tenku and explore other games near you.",
      "open.preview.download.scanQR": "Scan the QR with your phone",

      // Common
      "common.privacy": "Privacy",
      "common.terms": "Terms",
      "common.loading": "Loading...",

      // Venues (B2B)
      "venues.header.features": "Benefits",
      "venues.header.how": "How It Works",
      "venues.header.contact": "Contact",
      "venues.header.playersApp": "Are you a player?",
      "venues.hero.badge": "For venue owners and managers",
      "venues.hero.title": "Manage your courts",
      "venues.hero.titleHighlight": "without notebooks or chaos",
      "venues.hero.subtitle": "Booking calendar, payment tracking and customer base in one place. Manage your venue from your phone or computer.",
      "venues.hero.ctaPrimary": "Request a demo",
      "venues.hero.ctaSecondary": "See benefits",
      "venues.video.title": "See how it works in under 3 minutes",
      "venues.video.subtitle": "A real walkthrough of the panel: free slots, bookings, requests and payments (video in Spanish).",
      "venues.video.play": "Play video",
      "venues.video.duration": "2:39",
      "venues.features.title": "Your Whole Business in One Panel",
      "venues.features.subtitle": "Leave the notebook and spreadsheets behind: manage bookings, payments and customers without losing control of your day.",
      "venues.features.calendar.title": "Booking Calendar",
      "venues.features.calendar.description": "See each court's occupancy by day and hour. Register a booking in seconds and avoid schedule conflicts.",
      "venues.features.spaces.title": "Your Courts and Schedules",
      "venues.features.spaces.description": "Set up your spaces, sports, opening hours and rates. Everything adapts to how your business works.",
      "venues.features.payments.title": "Payment Tracking",
      "venues.features.payments.description": "Record deposits, balances and debts for each booking to reconcile your cash at the end of the day.",
      "venues.features.customers.title": "Customer Base",
      "venues.features.customers.description": "Identify your frequent customers and check their booking history and pending payments.",
      "venues.features.visibility.title": "Visibility in the Tenku App",
      "venues.features.visibility.description": "Your venue appears on the map where Tenku players organize their games and look for places to play.",
      "venues.features.anywhere.title": "From Any Device",
      "venues.features.anywhere.description": "Works on the web, nothing to install: manage from your phone, tablet or computer.",
      "venues.how.title": "Getting Started Is Simple",
      "venues.how.subtitle": "In three steps your venue is up and running with Tenku.",
      "venues.how.step1.title": "Tell Us About Your Venue",
      "venues.how.step1.description": "Leave us your details and we'll contact you to show you the system with a demo.",
      "venues.how.step2.title": "Set Up Your Spaces",
      "venues.how.step2.description": "We help you register your courts, schedules and rates so everything is ready from day one.",
      "venues.how.step3.title": "Manage Your Bookings",
      "venues.how.step3.description": "Keep your calendar, payments and customers up to date from a single panel.",
      "venues.contact.title": "Let's Talk About Your Venue",
      "venues.contact.subtitle": "Leave us your details and we'll contact you to schedule a no-commitment demo.",
      "venues.contact.name": "Your name",
      "venues.contact.namePlaceholder": "First and last name",
      "venues.contact.venueName": "Name of your venue",
      "venues.contact.venueNamePlaceholder": "E.g. San Martin Sports Complex",
      "venues.contact.city": "City",
      "venues.contact.cityPlaceholder": "E.g. Trujillo",
      "venues.contact.phone": "Phone / WhatsApp",
      "venues.contact.phonePlaceholder": "E.g. 999 999 999",
      "venues.contact.email": "Email (optional)",
      "venues.contact.emailPlaceholder": "you@example.com",
      "venues.contact.message": "Tell us more (optional)",
      "venues.contact.messagePlaceholder": "How many courts do you have? Which sports?",
      "venues.contact.submit": "Send",
      "venues.contact.sending": "Sending...",
      "venues.contact.success": "Thank you! We'll contact you very soon.",
      "venues.contact.error": "We couldn't send the form. Try again or write to support@tenkusports.com.",
      "venues.contact.privacy": "We'll only use your data to contact you. No spam.",
      "venues.header.pricing": "Pricing",
      "audience.label": "Tenku for",
      "audience.players": "Players",
      "audience.venues": "Venues",
      "venues.header.login": "Log in to the panel",
      "venuesBand.eyebrow": "For venue owners",
      "venuesBand.title": "Own a sports venue? Run it with Tenku",
      "venuesBand.text": "Bookings, payments and customers in one place, from your phone or computer. And Tenku players can find you and book online.",
      "venuesBand.cta": "Discover Tenku for venues",
      "venuesBand.login": "Log in to the panel",
      "venues.pricing.title": "A Plan for Every Venue",
      "venues.pricing.subtitle": "Start free and grow at your own pace. All prices are per location, with unlimited courts.",
      "venues.pricing.billing": "Billing",
      "venues.pricing.monthly": "Monthly",
      "venues.pricing.yearly": "Yearly",
      "venues.pricing.yearlySave": "2 months free",
      "venues.pricing.recommended": "Recommended",
      "venues.pricing.comingSoon": "Coming soon",
      "venues.pricing.perMonth": "/mo",
      "venues.pricing.billedYearly": "{{amount}} billed yearly, per location",
      "venues.pricing.perBranch": "Per location, unlimited courts",
      "venues.pricing.freeForever": "Free forever",
      "venues.pricing.ctaFree": "Create free account",
      "venues.pricing.ctaTrial": "Try 2 months free",
      "venues.pricing.ctaStart": "Get started",
      "venues.pricing.factTrial": "Sign up and get 2 months of Pro for free, no card required.",
      "venues.pricing.factData": "If you change plans, your data stays.",
      "venues.pricing.factPayment": "Pay by bank transfer.",
      "venues.pricing.demoQuestion": "Would you rather see it first?",
      "venues.pricing.demoLink": "Request a demo",
      "venues.pricing.free.name": "Free",
      "venues.pricing.free.tagline": "Get on Tenku and ditch the notebook.",
      "venues.pricing.free.f1": "Verified venue on the Tenku app",
      "venues.pricing.free.f2": "Button for players to message you on WhatsApp or call you",
      "venues.pricing.free.f3": "Manual bookings in the daily list",
      "venues.pricing.free.f4": "Time blocks",
      "venues.pricing.free.f5": "Daily summary",
      "venues.pricing.free.f6": "1 post per month on the Tenku feed (coming soon)",
      "venues.pricing.starter.name": "Starter",
      "venues.pricing.starter.tagline": "Go digital and get bookings from the app.",
      "venues.pricing.starter.includes": "Everything in Free, plus:",
      "venues.pricing.starter.f1": "Bookings from the Tenku app",
      "venues.pricing.starter.f2": "New booking notifications",
      "venues.pricing.starter.f3": "Notifications to your app customers",
      "venues.pricing.starter.f4": "Weekly calendar for all your courts",
      "venues.pricing.starter.f5": "Pending bookings with a hold deadline",
      "venues.pricing.starter.f6": "Recurring weekly bookings",
      "venues.pricing.starter.f7": "Payment receipts on every booking",
      "venues.pricing.starter.f8": "Up to 2 staff users",
      "venues.pricing.starter.f9": "Reports up to the month, compared with the previous period",
      "venues.pricing.starter.f10": "What Tenku brought you: bookings and payments from the app",
      "venues.pricing.starter.f11": "4 posts per month on the feed (coming soon)",
      "venues.pricing.pro.name": "Pro",
      "venues.pricing.pro.tagline": "Run your whole venue from one panel.",
      "venues.pricing.pro.includes": "Everything in Starter, plus:",
      "venues.pricing.pro.f1": "Shop: products, stock, sales and cash closing",
      "venues.pricing.pro.f2": "Events: book your courts and spaces for birthdays, companies and more",
      "venues.pricing.pro.f3": "Customers: who comes back and who stopped coming",
      "venues.pricing.pro.f4": "Loyalty promotions: every N hours played, a reward",
      "venues.pricing.pro.f5": "Unlimited staff",
      "venues.pricing.pro.f6": "Full reports: occupancy by day and hour and unsold hours",
      "venues.pricing.pro.f7": "Opportunities: weak time slots and customers to offer a fixed slot",
      "venues.pricing.pro.f8": "Balances to collect and what you lost to no-shows and cancellations",
      "venues.pricing.pro.f9": "CSV export",
      "venues.pricing.pro.f10": "Unlimited feed posts (coming soon)",
      "venues.pricing.growth.name": "Growth",
      "venues.pricing.growth.tagline": "Fill your hours and grow your business.",
      "venues.pricing.growth.includes": "Everything in Pro, plus:",
      "venues.pricing.growth.f1": "Featured on the Tenku feed",
      "venues.pricing.growth.f2": "Priority in app searches",
      "venues.pricing.growth.f3": "Discounted hours to fill off-peak times",

      "sim.docTitle": "Bracket simulator | Tenku",
      "sim.title": "Bracket simulator",
      "sim.subtitle": "Plan your knockout tournament before booking the venue: pick teams, format and availability, and see how many matches you get and what time everything ends.",
      "sim.tournament": "Tournament",
      "sim.teams": "Teams",
      "sim.formatByes": "Bracket with byes",
      "sim.formatLL": "Lucky loser",
      "sim.matchMin": "Match (min)",
      "sim.restMin": "Turnaround between matches (min)",
      "sim.teamRestMin": "Minimum rest per team (min)",
      "sim.thirdPlace": "Third-place match",
      "sim.ceremony": "Awards at the end",
      "sim.ceremonyMin": "Awards (min)",
      "sim.courtsTitle": "Fields and availability",
      "sim.court": "Field",
      "sim.addCourt": "+ Add field",
      "sim.removeCourt": "Remove field",
      "sim.from": "from",
      "sim.to": "to",
      "sim.hintByes": "Bracket of {{target}}; teams with a bye (advance directly): {{byes}}; first-round matchups: {{played}}.",
      "sim.hintByesNone": "Bracket of {{target}}: no byes, everyone plays the first round.",
      "sim.hintLL": "With {{n}} teams you play a bracket of {{target}} (teams with a bye in Round 1: {{byes}}) and the best loser of the last preliminary round is revived to complete the {{phase}}.",
      "sim.hintLLNoByes": "With {{n}} teams you play a bracket of {{target}}: everyone plays from Round 1 and the best loser of the last preliminary round is revived to complete the {{phase}}.",
      "sim.hintLLResolved": "With {{n}} teams the lucky loser resolves to the regular bracket (the fill lands on a power of 2: bracket of {{target}}).",
      "sim.phaseSemis": "semifinals",
      "sim.phaseQuarters": "quarterfinals",
      "sim.phaseR16": "round of 16",
      "sim.phaseR32": "round of 32",
      "sim.matches": "Matches",
      "sim.rounds": "Rounds",
      "sim.endsAt": "Everything ends",
      "sim.playTime": "Playing time",
      "sim.warnNoFit": "{{count}} matches ({{list}}) don't fit in the current availability. Extend a field's window by about {{min}} min, add a field or shorten the matches.",
      "sim.schedTitle": "Schedule by field",
      "sim.bracketTitle": "Bracket structure",
      "sim.noMatches": "no matches assigned",
      "sim.ceremonyLabel": "Awards",
      "sim.thirdShort": "3rd place",
      "sim.semiLosers": "Semifinal losers",
      "sim.repechageNote": "When {{round}} is done, the organizer confirms in the app which best loser is revived (defeat margin, then score, then draw).",
      "sim.byeAdvances": "{{team}} advances directly",
      "sim.winnerOf": "Winner of {{id}}",
      "sim.prelimWinner": "Winner {{n}} of the previous round",
      "sim.luckyLoser": "Best loser",
      "sim.llBadge": "LL",
      "sim.roundN": "Round {{n}}",
      "sim.r64": "Round of 64",
      "sim.r32": "Round of 32",
      "sim.r16": "Round of 16",
      "sim.qf": "Quarterfinals",
      "sim.sf": "Semifinals",
      "sim.final": "Final",
      "sim.matchOne": "1 match",
      "sim.matchMany": "{{count}} matches",
      "sim.ctaTitle": "Does it fit? Create it on Tenku",
      "sim.ctaSubtitle": "Create the tournament in the app: automatic draw, fixture, results and live standings for every team.",
      "sim.ctaButton": "Create my tournament on Tenku",
      "sim.ctaStores": "Free on the App Store and Google Play",
      "sim.footNote": "Simulation with the same generation rules as Tenku; the draw in the app decides which team lands in each matchup.",

      // Refer
      "refer.pageTitle": "Recommend a venue and earn S/ 200 | Tenku",
      "refer.hero.badge": "Peru only",
      "refer.hero.title": "Recommend a venue and earn",
      "refer.hero.titleHighlight": "S/ 200",
      "refer.hero.subtitle": "Do you play at a venue that doesn't use Tenku yet? Convince it to sign up and earn S/ 200 when it starts a paid plan.",
      "refer.hero.ctaTerms": "See terms",
      "refer.how.title": "How it works",
      "refer.how.step1.title": "Talk to your venue",
      "refer.how.step1.description": "Ask the venue where you play to sign up on Tenku so you can book from the app. We give you a ready-made message to send by WhatsApp.",
      "refer.how.step2.title": "The venue signs up",
      "refer.how.step2.description": "Once it signs up, let us know the venue name and your username. We confirm with the owner that you recommended it.",
      "refer.how.step3.title": "You get S/ 200",
      "refer.how.step3.description": "When the venue completes 3 paid months or signs up for an annual plan, we pay you by Yape or bank transfer.",
      "refer.terms.title": "Terms and conditions",
      "refer.terms.who.title": "Who can take part",
      "refer.terms.who.body": "Tenku users aged 18 or older who live in Peru.",
      "refer.terms.venues.title": "Which venues count",
      "refer.terms.venues.body": "Sports venues in Peru that don't have a Tenku account at the time of the recommendation.",
      "refer.terms.how.title": "How to recommend",
      "refer.terms.how.body": "Ask the venue to sign up on Tenku and write to support@tenkusports.com with the venue name and your username. Tenku confirms with the owner who recommended it.",
      "refer.terms.when.title": "When you earn it",
      "refer.terms.when.body": "You earn S/ 200 when the recommended venue completes 3 paid months of any plan, or signs up for an annual plan. Free usage does not count toward the 3 months.",
      "refer.terms.once.title": "One reward per venue",
      "refer.terms.once.body": "It is paid only once per venue, even if it has several branches. If two people recommend the same venue, the reward goes to the first one who reported it.",
      "refer.terms.payment.title": "How it is paid",
      "refer.terms.payment.body": "By Yape or bank transfer, within 15 days after the condition is met.",
      "refer.terms.changes.title": "Changes",
      "refer.terms.changes.body": "Tenku may change or end this promotion at any time. Recommendations registered before the change keep the conditions they were made under.",
      "refer.share.cta": "Share with the venue",
      "refer.share.message": "Hi, I play at your venue and I'd like to book through Tenku. It's an app to book courts and organize games and tournaments, and it keeps your bookings organized. You can start for free: https://tenkusports.com/venues",
      "refer.report.title": "Did your venue sign up?",
      "refer.report.description": "Write to us with the venue name and your username to register your recommendation.",
      "refer.report.cta": "Let Tenku know",
      "refer.emailNote": "You can also write to us directly at",
      "refer.mail.subject": "I convinced a venue",
      "refer.mail.body": "Venue name:\nDistrict:\n\nMy name:\nMy Tenku username:\nMy phone:\n",
    }
  },
  pt: {
    translation: {
      // Header
      "header.home": "Início",
      "header.features": "Recursos",
      "header.howItWorks": "Como Funciona",
      "header.testimonials": "Problemas",
      "header.faq": "FAQ",
      "header.signup": "Participar",
      "header.backToTenku": "Voltar ao Tenku",
      "header.openWeb": "Entrar na web",

      // Hero
      "hero.title": "Conecte-se com sua",
      "hero.titleHighlight": "Comunidade Esportiva",
      "hero.subtitle": "Descubra jogos perto de você, organize equipes e torneios e conecte-se com outros atletas. Seu próximo jogo está a um toque de distância.",
      "hero.ctaPrimary": "Baixar Agora",
      "hero.ctaSecondary": "Saiba Mais",
      "hero.ctaWeb": "Usar no navegador",
      "hero.nowAvailable": "Disponível Agora!",
      "hero.downloadSubtitle": "Baixe o app no iOS ou Android, ou use pelo navegador, e conecte-se com sua comunidade esportiva hoje mesmo.",
      "hero.badge": "Disponível para iOS, Android e web",
      "hero.cardGame.title": "Pelada 7v7",
      "hero.cardGame.meta": "8/14 jogadores · Hoje 20:00",
      "hero.cardNear.title": "Perto de você",
      "hero.cardNear.meta": "A 1,2 km · 5 jogos abertos",

      // Features
      "features.title": "Tudo que Você Precisa para Jogar",
      "features.subtitle": "Tenku oferece todas as ferramentas para se conectar com outros atletas, organizar jogos e fazer crescer sua paixão pelo esporte.",
      "features.findGames.title": "Encontre Jogos Por Perto",
      "features.findGames.description": "Use nosso mapa interativo para descobrir jogos e eventos esportivos em sua área instantaneamente.",
      "features.organizeTeams.title": "Organize Suas Equipes",
      "features.organizeTeams.description": "Crie perfis de equipe, convide jogadores e gerencie seu elenco facilmente.",
      "features.tournaments.title": "Organize Torneios",
      "features.tournaments.description": "Crie seu torneio, convide as equipes e acompanhe a tabela de jogos, os resultados e a classificação pelo app.",
      "features.lineups.title": "Formações e Escalações",
      "features.lineups.description": "Monte a escalação da sua equipe no campo, defina as posições e compartilhe antes de cada partida.",
      "features.arrival.title": "Acompanhe a Partida ao Vivo",
      "features.arrival.description": "Confirme sua chegada com um toque e veja em tempo real quem já chegou, até pela tela de bloqueio.",
      "features.chat.title": "Chat Integrado",
      "features.chat.description": "Cada jogo e cada equipe tem seu próprio chat: coordene tudo em um só lugar, sem correntes intermináveis de mensagens.",
      "features.playerSearch.title": "Encontre Jogadores",
      "features.playerSearch.description": "Busque atletas por esporte, veja o perfil e conecte-se para o seu próximo jogo.",
      "features.notifications.title": "Notificações em Tempo Real",
      "features.notifications.description": "Receba alertas sobre novos jogos, convites de equipe e mensagens de outros jogadores.",
      "features.personalStats.title": "Estatísticas Pessoais",
      "features.personalStats.description": "Acompanhe seus jogos, melhore seu desempenho e compartilhe suas conquistas com a comunidade.",
      "features.booking.title": "Reserve sua Quadra",
      "features.booking.description": "Abra o link do seu local, escolha um horário livre e envie sua reserva pelo app. O local confirma e você acompanha o status em Minhas reservas.",

      // How It Works
      "howItWorks.title": "Como Funciona?",
      "howItWorks.subtitle": "Em apenas três passos simples você estará conectado com a comunidade esportiva da sua cidade.",
      "howItWorks.step1.title": "Crie seu Perfil",
      "howItWorks.step1.description": "Cadastre-se e complete seu perfil esportivo com seus esportes favoritos e nível de habilidade.",
      "howItWorks.step2.title": "Encontre ou Crie Jogos",
      "howItWorks.step2.description": "Explore jogos perto de você ou crie os seus próprios para outros participarem.",
      "howItWorks.step3.title": "Conecte-se e Jogue",
      "howItWorks.step3.description": "Participe de jogos, conheça novos atletas e divirta-se jogando seu esporte favorito.",

      // Testimonials
      "testimonials.title": "Isso te Soa Familiar?",
      "testimonials.subtitle": "Estes são os problemas mais comuns que os atletas enfrentam hoje em dia.",
      "testimonials.subtitleHighlight": " Tenku resolve todos eles.",
      "testimonials.problem1.title": "Equipes Incompletas",
      "testimonials.problem1.description": "Sempre falta alguém. Você organiza um jogo de futebol e só aparecem 6 pessoas. Impossível jogar!",
      "testimonials.problem2.title": "Sem Parceiros de Jogo",
      "testimonials.problem2.description": "Quero jogar tênis mas meus amigos sempre estão ocupados. Acabo treinando sozinho de novo.",
      "testimonials.problem3.title": "Coordenação Impossível",
      "testimonials.problem3.description": "WhatsApp cheio de mensagens para organizar UM jogo. Ninguém entra em acordo sobre o horário.",
      "testimonials.problem4.title": "Quadras Vazias",
      "testimonials.problem4.description": "Chego na quadra e não tem ninguém jogando. Gostaria de ter me juntado a algum grupo.",
      "testimonials.problem5.title": "Horários Limitados",
      "testimonials.problem5.description": "Só posso jogar em certos dias mas meu grupo habitual não coincide. Meu tempo livre é desperdiçado.",
      "testimonials.problem6.title": "Cidade Nova",
      "testimonials.problem6.description": "Me mudei e não conheço ninguém que jogue meu esporte favorito. Como encontro pessoas aqui?",

      // Downloads
      "downloads.title": "Baixe Tenku Agora!",
      "downloads.subtitle": "O app está disponível no iOS e Android, e você também pode usá-lo pelo navegador sem instalar nada. Junte-se à nossa comunidade de atletas hoje mesmo!",
      "downloads.downloadOn": "Baixar em",
      "downloads.appStore": "App Store",
      "downloads.googlePlay": "Google Play",
      "downloads.appStoreLink": "https://apps.apple.com/pe/app/sports-nest/id6753092450",
      "downloads.googlePlayLink": "https://play.google.com/store/apps/details?id=com.jabanto.sportsnest",
      "downloads.availableNow": "✅ O app está disponível agora em ambas as plataformas",
      "downloads.scanQr": "Escaneie o código com a câmera do seu celular para baixar o app.",
      "downloads.webLabel": "Sem instalar",
      "downloads.webName": "Versão web",
      "downloads.webLink": "https://app.tenkusports.com",
      "downloads.webNote": "Ideal se seu celular não é compatível com o app ou se você organiza torneios pelo notebook.",
      "downloads.betaNotice": "📱 Disponível agora no iOS e Android",

      // FAQ
      "faq.title": "Perguntas Frequentes",
      "faq.subtitle": "Respondemos as dúvidas mais comuns sobre o Tenku.",
      "faq.q1.question": "Posso participar de um jogo se sou iniciante?",
      "faq.q1.answer": "Claro! No Tenku você pode filtrar jogos por nível de habilidade. Há uma comunidade acolhedora para todos, desde iniciantes até jogadores avançados.",
      "faq.q2.question": "Como funciona a criação de equipes?",
      "faq.q2.answer": "Você pode criar o perfil da sua equipe, convidar jogadores com um link, gerenciar seu elenco e montar a escalação de cada partida.",
      "faq.q3.question": "É seguro conhecer pessoas através do app?",
      "faq.q3.answer": "A segurança é nossa prioridade. Temos perfis verificados, um sistema de avaliação de jogadores e recomendamos sempre jogar em lugares públicos e conhecidos.",
      "faq.q4.question": "O Tenku estará disponível na minha cidade?",
      "faq.q4.answer": "O Tenku funcionará em qualquer cidade desde o primeiro dia. A comunidade esportiva de cada lugar crescerá organicamente: quanto mais usuários convidarem seus amigos, mais ativa será a rede local. Seja o pioneiro na sua cidade!",
      "faq.q5.question": "Posso organizar um torneio no Tenku?",
      "faq.q5.answer": "Sim. Crie seu torneio, convide as equipes e gerencie a tabela de jogos, os resultados e a classificação direto pelo app.",
      "faq.q6.question": "O aplicativo é gratuito?",
      "faq.q6.answer": "Sim, o Tenku é gratuito. Você pode encontrar jogos, criar equipes e organizar torneios sem pagar nada.",
      "faq.q7.question": "Meu celular não é compatível com o app?",
      "faq.q7.answer": "Você pode usar o Tenku pelo navegador em app.tenkusports.com com a mesma conta: encontrar jogos e torneios, inscrever sua equipe, aceitar convites e organizar seus torneios. O chat e algumas funções ficam só no app.",

      // Footer
      "footer.description": "Conectando atletas e criando comunidades esportivas em todo o mundo. Seu próximo jogo está a um toque de distância.",
      "footer.copyright": "© {{year}} Tenku. Todos os direitos reservados.",
      "footer.product": "Produto",
      "footer.legal": "Legal",
      "footer.tagline": "Jogue sem desculpas",
      "footer.forVenues": "Administra uma quadra?",
      "footer.forPlayers": "É jogador? Conheça o app",
      "footer.descriptionVenues": "Reservas, pagamentos e clientes da sua quadra em um só lugar, e jogadores que te encontram no Tenku.",
      "footer.webApp": "Usar o Tenku no navegador",

      // Legal pages
      "legal.privacyTitle": "Política de Privacidade",
      "legal.termsTitle": "Termos e Condições",
      "legal.lastUpdated": "Última atualização:",

      // Privacy Policy
      "privacy.section1.title": "1. Informações que Coletamos",
      "privacy.section1.intro": "No Tenku, coletamos as seguintes informações para oferecer uma melhor experiência:",
      "privacy.section1.accountInfo": "Informações da conta: nome, email, idade, foto do perfil",
      "privacy.section1.sportsInfo": "Informações esportivas: esportes favoritos, nível de habilidade, disponibilidade",
      "privacy.section1.locationInfo": "Informações de localização: localização aproximada para mostrar jogos perto de você (apenas quando usar o app)",
      "privacy.section1.commInfo": "Dados de comunicação: mensagens com outros usuários, convites",
      "privacy.section1.usageInfo": "Dados de uso: como você interage com o app, preferências, estatísticas de jogos",
      "privacy.section1.deviceInfo": "Informações do dispositivo: identificador único, sistema operacional, tipo de dispositivo",
      "privacy.section1.authInfo": "Dados de autenticação: informações do Apple ID, Google, Facebook se você usar login social",

      "privacy.section2.title": "2. Como Usamos suas Informações",
      "privacy.section2.intro": "Usamos suas informações para:",
      "privacy.section2.connect": "Conectá-lo com outros atletas em sua área",
      "privacy.section2.showGames": "Mostrar jogos e eventos relevantes",
      "privacy.section2.notifications": "Enviar notificações sobre convites e atualizações",
      "privacy.section2.security": "Melhorar a segurança e funcionalidade do aplicativo",
      "privacy.section2.support": "Fornecer suporte técnico quando necessário",

      "privacy.section3.title": "3. Compartilhamento de Informações",
      "privacy.section3.intro": "Não vendemos nem alugamos suas informações pessoais. Compartilhamos informações limitadas apenas quando:",
      "privacy.section3.necessary": "É necessário para conectá-lo com outros usuários do aplicativo",
      "privacy.section3.legal": "Exigido por lei ou autoridades competentes",
      "privacy.section3.safety": "É necessário para proteger a segurança de nossos usuários",

      "privacy.section4.title": "4. Segurança de Dados",
      "privacy.section4.intro": "Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações pessoais:",
      "privacy.section4.encryption": "Criptografia de dados em trânsito e em repouso",
      "privacy.section4.auth": "Autenticação segura e tokens de acesso",
      "privacy.section4.servers": "Servidores seguros com acesso limitado",
      "privacy.section4.monitoring": "Monitoramento contínuo de segurança",
      "privacy.section4.compliance": "Conformidade com padrões da indústria",

      "privacy.section5.title": "5. Retenção de Dados",
      "privacy.section5.intro": "Retemos suas informações pessoais apenas pelo tempo necessário para:",
      "privacy.section5.services": "Fornecer nossos serviços",
      "privacy.section5.legal": "Cumprir obrigações legais",
      "privacy.section5.disputes": "Resolver disputas",
      "privacy.section5.deletion": "Se você excluir sua conta, excluiremos suas informações em 30 dias",

      "privacy.section6.title": "6. Transferências Internacionais",
      "privacy.section6.content": "Seus dados podem ser processados em servidores localizados fora do seu país de residência. Garantimos o mesmo nível de proteção através de acordos apropriados de transferência de dados.",

      "privacy.section7.title": "7. Menores de Idade",
      "privacy.section7.content": "O Tenku não é direcionado a crianças menores de 13 anos. Não coletamos intencionalmente informações pessoais de crianças menores de 13 anos. Se descobrirmos que coletamos informações de uma criança menor de 13 anos, a excluiremos imediatamente.",

      "privacy.section8.title": "8. Seus Direitos",
      "privacy.section8.intro": "Você tem o direito de:",
      "privacy.section8.access": "Acessar suas informações pessoais",
      "privacy.section8.correct": "Corrigir informações incorretas",
      "privacy.section8.delete": "Excluir sua conta e dados",
      "privacy.section8.portability": "Portabilidade de seus dados",
      "privacy.section8.object": "Opor-se ao processamento de seus dados",

      "privacy.section9.title": "9. Alterações nesta Política",
      "privacy.section9.content": "Podemos atualizar esta política de privacidade ocasionalmente. Notificaremos sobre mudanças significativas através do aplicativo ou por email. Seu uso continuado do Tenku após as alterações constitui sua aceitação da nova política.",

      "privacy.section10.title": "10. Contato",
      "privacy.section10.content": "Se você tiver dúvidas sobre esta política de privacidade, entre em contato conosco em:",
      "privacy.section10.email": "Email: privacy@tenkusports.com",

      // Terms
      "terms.section1.title": "1. Aceitação dos Termos",
      "terms.section1.content": "Ao acessar e usar o Tenku, você concorda em estar legalmente vinculado por estes termos e condições. Se não concordar com algum destes termos, não use nossos serviços.",

      "terms.section2.title": "2. Descrição do Serviço",
      "terms.section2.intro": "Tenku é uma plataforma que conecta atletas e entusiastas do esporte para:",
      "terms.section2.find": "Encontrar e participar de jogos esportivos locais",
      "terms.section2.organize": "Organizar equipes e eventos esportivos",
      "terms.section2.connect": "Conectar-se com outros atletas em sua área",
      "terms.section2.participate": "Participar de torneios e competições",

      "terms.section3.title": "3. Registro e Conta de Usuário",
      "terms.section3.intro": "Para usar o Tenku, você deve:",
      "terms.section3.age": "Ter mais de 13 anos (menores precisam de consentimento dos pais)",
      "terms.section3.accurate": "Fornecer informações precisas e atualizadas",
      "terms.section3.security": "Manter a segurança de sua conta e senha",
      "terms.section3.notify": "Notificar imediatamente qualquer uso não autorizado",

      "terms.section4.title": "4. Conduta do Usuário",
      "terms.section4.intro": "Ao usar o Tenku, você se compromete a:",
      "terms.section4.respectful": "Comportar-se respeitosamente com outros usuários",
      "terms.section4.noOffensive": "Não publicar conteúdo ofensivo, discriminatório, violento ou inapropriado",
      "terms.section4.noIllegal": "Não usar a plataforma para atividades ilegais ou fraudulentas",
      "terms.section4.noHarass": "Não assediar, intimidar ou ameaçar outros usuários",
      "terms.section4.noFake": "Não criar contas falsas ou se passar por outras pessoas",
      "terms.section4.noSpam": "Não enviar spam ou conteúdo promocional não solicitado",
      "terms.section4.ip": "Respeitar a propriedade intelectual de terceiros",
      "terms.section4.noInterfere": "Não interferir no funcionamento do aplicativo",
      "terms.section4.rules": "Cumprir as regras específicas de cada evento esportivo",

      "terms.section5.title": "5. Segurança e Responsabilidade",
      "terms.section5.important": "Importante:",
      "terms.section5.intro": "A participação em atividades esportivas carrega riscos inerentes. Ao usar o Tenku:",
      "terms.section5.ownRisk": "Você participa por sua própria conta e risco",
      "terms.section5.insurance": "Você deve ter seguro médico apropriado",
      "terms.section5.notResponsible": "Tenku não é responsável por lesões ou danos",
      "terms.section5.recommend": "Recomendamos conhecer outros usuários em lugares públicos",

      "terms.section6.title": "6. Conteúdo do Usuário",
      "terms.section6.content": "Ao publicar conteúdo no Tenku (fotos, mensagens, etc.), você concede ao Tenku uma licença limitada para exibir esse conteúdo dentro do aplicativo. Você mantém todos os direitos sobre seu conteúdo e pode excluí-lo a qualquer momento.",

      "terms.section7.title": "7. Propriedade Intelectual",
      "terms.section7.content": "Tenku e todo seu conteúdo (design, código, logos, textos) são propriedade da empresa e estão protegidos pelas leis de propriedade intelectual. Você não pode copiar, modificar ou distribuir qualquer conteúdo do aplicativo sem autorização expressa.",

      "terms.section8.title": "8. Pagamentos e Assinaturas",
      "terms.section8.content": "Tenku oferece recursos básicos gratuitos e recursos premium pagos. Os pagamentos são processados através da Apple App Store ou Google Play Store. As políticas de reembolso estão sujeitas aos termos dessas plataformas.",

      "terms.section9.title": "9. Limitação de Responsabilidade",
      "terms.section9.content": "Tenku é fornecido \"como está\". Não garantimos que o serviço seja ininterrupto ou livre de erros. Nossa responsabilidade está limitada ao máximo permitido por lei.",

      "terms.section10.title": "10. Lei Aplicável e Jurisdição",
      "terms.section10.content": "Estes termos são regidos pelas leis do país onde o Tenku opera. Qualquer disputa será resolvida através de arbitragem ou nos tribunais competentes de tal jurisdição.",

      "terms.section11.title": "11. Modificações",
      "terms.section11.content": "Reservamo-nos o direito de modificar estes termos a qualquer momento. Mudanças significativas serão notificadas através do aplicativo.",

      "terms.section12.title": "12. Terminação",
      "terms.section12.content": "Podemos encerrar ou suspender sua conta a qualquer momento por violação destes termos. Você também pode excluir sua conta a qualquer momento nas configurações do aplicativo.",

      "terms.section13.title": "13. Contato",
      "terms.section13.content": "Se você tiver dúvidas sobre estes termos, entre em contato conosco em:",
      "terms.section13.email": "Email: legal@tenkusports.com",

      // Support
      "support.title": "Suporte",
      "support.subtitle": "Estamos aqui para ajudar você com qualquer dúvida sobre o Tenku.",
      "support.deleteAccount.title": "Exclusão de Conta",
      "support.deleteAccount.description": "Se você deseja excluir permanentemente sua conta do Tenku e todos os dados associados, pode solicitar seguindo estes passos:",
      "support.deleteAccount.steps.title": "Passos para excluir sua conta:",
      "support.deleteAccount.steps.step1": "Envie um email para support@tenkusports.com",
      "support.deleteAccount.steps.step2": "Inclua no assunto: 'Solicitação de exclusão de conta'",
      "support.deleteAccount.steps.step3": "Forneça seu email registrado e confirme que deseja excluir permanentemente sua conta",
      "support.deleteAccount.thirdParty.title": "Contas vinculadas com terceiros",
      "support.deleteAccount.thirdParty.description": "Se você se registrou usando serviços de terceiros, também processaremos a desvinculação automaticamente:",
      "support.deleteAccount.thirdParty.google": "Será automaticamente desvinculado da sua conta do Google",
      "support.deleteAccount.thirdParty.facebook": "Será automaticamente desvinculado da sua conta do Facebook",
      "support.deleteAccount.warning.title": "Importante",
      "support.deleteAccount.warning.description": "Esta ação é irreversível. Todos os seus dados, jogos, conexões e informações de perfil serão excluídos permanentemente.",
      "support.contactButton": "Contatar Suporte",

      // 404 Page
      "notFound.title": "Ops! Página não encontrada",
      "notFound.subtitle": "Parece que esta página foi jogar em outro campo",
      "notFound.description": "A página que você está procurando não existe ou foi movida. Mas não se preocupe, temos muitas outras coisas legais para mostrar!",
      "notFound.backHome": "Voltar ao Início",
      "notFound.getHelp": "Obter Ajuda",
      "notFound.tip": "💡 Dica:",
      "notFound.tipDescription": "Enquanto esperamos o lançamento do Tenku, você pode entrar em nossa lista de espera para ser o primeiro a se conectar com sua comunidade esportiva.",

      // Open page
      "open.title": "Abra este conteúdo no Tenku",
      "open.subtitle": "Escaneie o código QR com seu celular para abrir este conteúdo no app.",
      "open.scanQR": "Escaneie com a câmera do seu celular",
      "open.opening": "Abrindo Tenku...",
      "open.appNotInstalled": "Não tem o app?",
      "open.downloadToOpen": "Baixe o Tenku para ver este conteúdo.",
      "open.downloadAppStore": "Baixar na App Store",
      "open.downloadGooglePlay": "Baixar no Google Play",
      "open.tryAgain": "Tentar abrir novamente",
      "open.copiedHint": "Guardamos o link; ele vai te levar até lá ao abrir o app.",

      "invite.title": "Você foi convidado para jogar no Tenku",
      "invite.subtitle": "Baixe o app e aceite o convite.",
      "invite.copiedHint": "Seu convite foi copiado; será aplicado ao abrir o app.",
      "invite.desktopSubtitle": "Escaneie o código QR com seu celular para abrir seu convite.",
      "venueLink.notFoundTitle": "Este local não existe ou não está mais disponível",
      "venueLink.notFoundText": "Confira o link com quem o compartilhou com você.",
      "venueLink.errorTitle": "Não conseguimos carregar o local",
      "venueLink.errorText": "Verifique sua conexão e tente novamente.",
      "venueLink.retry": "Tentar novamente",
      "venueLink.goHome": "Ir para o Tenku",
      "venueLink.courts": "Quadras",
      "venueLink.courtCount_one": "{{count}} quadra",
      "venueLink.courtCount_other": "{{count}} quadras",
      "venueLink.courtCountIndoor_one": "{{count}} quadra coberta",
      "venueLink.courtCountIndoor_other": "{{count}} quadras cobertas",
      "venueLink.indoorCount_one": "{{count}} coberta",
      "venueLink.indoorCount_other": "{{count}} cobertas",
      "venueLink.priceFrom": "A partir de {{price}}",
      "venueLink.amenities": "Comodidades",
      "venueLink.amenityParking": "Estacionamento",
      "venueLink.amenityLockerRooms": "Vestiários",
      "venueLink.amenityShowers": "Chuveiros",
      "venueLink.amenityRestrooms": "Banheiros",
      "venueLink.amenityCafeteria": "Lanchonete",
      "venueLink.amenityWifi": "Wi-Fi",
      "venueLink.amenityStands": "Arquibancada",
      "venueLink.amenityCovered": "Quadras cobertas",
      "venueLink.amenityLighting": "Iluminação noturna",
      "venueLink.amenityWheelchairAccess": "Acesso para cadeirantes",
      "venueLink.whatsapp": "WhatsApp",
      "venueLink.call": "Ligar",
      "venueLink.website": "Site",
      "venueLink.ctaBook": "Reservar no app",
      "venueLink.ctaView": "Ver no app",
      "venueLink.haveApp": "Já tenho o app",
      "venueLink.valueBook": "Baixe o Tenku grátis, veja os horários livres e envie sua solicitação.",
      "venueLink.iosPasteHint": "Ao abrir o app, toque em Permitir colar para ir direto a este local.",
      "venueLink.whatsappMessage": "Olá, encontrei vocês no Tenku. Tem quadra livre?",
      "venueLink.openInApp": "Abrir no app Tenku",
      "venueLink.desktopHint": "Escaneie o código QR com seu celular para abrir este local no app Tenku.",
      "venueLink.webOr": "ou",
      "venueLink.webBook": "Reservar pela web",
      "venueLink.webView": "Ver na web",
      "venueLink.webHint": "Sem baixar nada, direto do navegador.",
      "venueLink.eventSpaces": "Espaços para eventos",
      "venueLink.eventsWeHost": "Ideal para",
      "venueLink.upToPeople_one": "Até {{count}} pessoa",
      "venueLink.upToPeople_other": "Até {{count}} pessoas",
      "venueLink.includes": "Inclui {{items}}",
      "venueLink.quoteEvent": "Pedir orçamento",
      "venueLink.quoteEventSpaceMessage": "Olá, vi {{space}} de {{venue}} no Tenku e quero um orçamento para um evento",
      "venueLink.quoteEventMessage": "Olá, vi {{venue}} no Tenku e quero um orçamento para um evento",
      "open.continueWeb": "Continuar na web",
      "open.continueWebHint": "Sem instalar nada, direto do navegador.",

      // Open page - Game preview (sales-oriented)
      "open.preview.hero.subtitle": "Estão te esperando em {{venue}}",
      "open.preview.date.today": "Hoje às {{time}}",
      "open.preview.date.tomorrow": "Amanhã às {{time}}",
      "open.preview.date.thisWeek": "Este {{weekday}} às {{time}}",
      "open.preview.date.full": "{{date}} às {{time}}",
      "open.preview.countdown.today": "É hoje!",
      "open.preview.countdown.tomorrow": "É amanhã",
      "open.preview.countdown.days": "Faltam {{count}} dias",
      "open.preview.fomo.missingPlayers_one": "Falta 1 de {{total}} jogadores",
      "open.preview.fomo.missingPlayers_other": "Faltam {{count}} de {{total}} jogadores",
      "open.preview.fomo.missingTeams_one": "Falta 1 de {{total}} equipes",
      "open.preview.fomo.missingTeams_other": "Faltam {{count}} de {{total}} equipes",
      "open.preview.fomo.full": "Jogo cheio",
      "open.preview.host.organizes": "<s>{{name}}</s> organiza este jogo",
      "open.preview.host.beTheFirst": "Seja o primeiro a se inscrever",
      "open.preview.host.playersJoined_one": "+ 1 jogador inscrito",
      "open.preview.host.playersJoined_other": "+ {{count}} jogadores inscritos",
      "open.preview.host.beTheFirstTeam": "Sua equipe ainda pode entrar",
      "open.preview.host.teamsConfirmed_one": "1 equipe confirmada",
      "open.preview.host.teamsConfirmed_other": "{{count}} equipes confirmadas",
      "open.preview.venue.happeningAt": "Acontecendo em",
      "open.preview.venue.openMap": "Ver no mapa",
      "open.preview.pitch.heading": "Encontre seu próximo <em>jogo</em>",
      "open.preview.pitch.subtitle": "Descubra jogos perto de você, monte sua equipe e conheça atletas da sua região.",
      "open.preview.pitch.feature1": "Jogos perto",
      "open.preview.pitch.feature2": "Sua equipe",
      "open.preview.pitch.feature3": "Sua comunidade",
      "open.preview.cta.joinGame": "Entrar no jogo",
      "open.preview.cta.joinWithTeam": "Entrar com minha equipe",
      "open.preview.cta.joinGameSub": "Grátis · iOS e Android",
      "open.preview.cta.alreadyHaveApp": "Já tenho o app · Abrir",
      "open.preview.cta.linkCopied": "Link copiado",
      "open.preview.share.button": "Compartilhar",
      "open.preview.share.heading": "🏆 Quer jogar {{sport}}?",
      "open.preview.share.tagline": "Junte-se ao meu jogo no Tenku 👇",
      "open.preview.over.finalizedTitle": "Este jogo já aconteceu",
      "open.preview.over.cancelledTitle": "Este jogo foi cancelado",
      "open.preview.over.findMore": "Encontre mais jogos no Tenku. Baixe o app e descubra jogos perto de você.",
      "open.preview.notFound.title": "Não encontramos este jogo",
      "open.preview.notFound.subtitle": "Pode ter sido cancelado ou não está mais disponível. Baixe o Tenku e explore outros jogos perto de você.",
      "open.preview.download.scanQR": "Escaneie o QR com seu celular",

      // Common
      "common.privacy": "Privacidade",
      "common.terms": "Termos",
      "common.loading": "Carregando...",

      // Venues (B2B)
      "venues.header.features": "Benefícios",
      "venues.header.how": "Como Funciona",
      "venues.header.contact": "Contato",
      "venues.header.playersApp": "Você é jogador?",
      "venues.hero.badge": "Para donos e administradores de quadras",
      "venues.hero.title": "Gerencie suas quadras",
      "venues.hero.titleHighlight": "sem cadernos nem caos",
      "venues.hero.subtitle": "Calendário de reservas, controle de pagamentos e base de clientes em um só lugar. Administre sua quadra do celular ou do computador.",
      "venues.hero.ctaPrimary": "Quero uma demo",
      "venues.hero.ctaSecondary": "Ver benefícios",
      "venues.video.title": "Veja como funciona em menos de 3 minutos",
      "venues.video.subtitle": "Um tour real pelo painel: horários livres, reservas, solicitações e pagamentos (vídeo em espanhol).",
      "venues.video.play": "Reproduzir vídeo",
      "venues.video.duration": "2:39",
      "venues.features.title": "Todo o seu Negócio em um Só Painel",
      "venues.features.subtitle": "Deixe o caderno e as planilhas para trás: administre reservas, pagamentos e clientes sem perder o controle do seu dia.",
      "venues.features.calendar.title": "Calendário de Reservas",
      "venues.features.calendar.description": "Visualize a ocupação de cada quadra por dia e hora. Registre uma reserva em segundos e evite conflitos de horários.",
      "venues.features.spaces.title": "Suas Quadras e Horários",
      "venues.features.spaces.description": "Configure seus espaços, esportes, horários de atendimento e tarifas. Tudo se adapta a como o seu negócio funciona.",
      "venues.features.payments.title": "Controle de Pagamentos",
      "venues.features.payments.description": "Registre adiantamentos, saldos e dívidas de cada reserva para fechar seu caixa no fim do dia.",
      "venues.features.customers.title": "Base de Clientes",
      "venues.features.customers.description": "Identifique seus clientes frequentes e consulte o histórico de reservas e pagamentos pendentes.",
      "venues.features.visibility.title": "Visibilidade no App Tenku",
      "venues.features.visibility.description": "Sua quadra aparece no mapa onde os jogadores do Tenku organizam suas partidas e procuram onde jogar.",
      "venues.features.anywhere.title": "De Qualquer Dispositivo",
      "venues.features.anywhere.description": "Funciona na web, sem instalar nada: gerencie do seu celular, tablet ou computador.",
      "venues.how.title": "Começar é Simples",
      "venues.how.subtitle": "Em três passos sua quadra está funcionando com o Tenku.",
      "venues.how.step1.title": "Conte Sobre Sua Quadra",
      "venues.how.step1.description": "Deixe seus dados e entraremos em contato para mostrar o sistema com uma demo.",
      "venues.how.step2.title": "Configure Seus Espaços",
      "venues.how.step2.description": "Ajudamos você a registrar suas quadras, horários e tarifas para que tudo fique pronto desde o primeiro dia.",
      "venues.how.step3.title": "Gerencie Suas Reservas",
      "venues.how.step3.description": "Mantenha o calendário, os pagamentos e seus clientes em dia em um só painel.",
      "venues.contact.title": "Vamos Falar da Sua Quadra",
      "venues.contact.subtitle": "Deixe seus dados e entraremos em contato para agendar uma demo sem compromisso.",
      "venues.contact.name": "Seu nome",
      "venues.contact.namePlaceholder": "Nome e sobrenome",
      "venues.contact.venueName": "Nome da sua quadra ou complexo",
      "venues.contact.venueNamePlaceholder": "Ex. Complexo Esportivo San Martín",
      "venues.contact.city": "Cidade",
      "venues.contact.cityPlaceholder": "Ex. Trujillo",
      "venues.contact.phone": "Telefone / WhatsApp",
      "venues.contact.phonePlaceholder": "Ex. 999 999 999",
      "venues.contact.email": "Email (opcional)",
      "venues.contact.emailPlaceholder": "seuemail@exemplo.com",
      "venues.contact.message": "Conte mais para a gente (opcional)",
      "venues.contact.messagePlaceholder": "Quantas quadras você tem? Quais esportes?",
      "venues.contact.submit": "Enviar",
      "venues.contact.sending": "Enviando...",
      "venues.contact.success": "Obrigado! Entraremos em contato em breve.",
      "venues.contact.error": "Não foi possível enviar o formulário. Tente novamente ou escreva para support@tenkusports.com.",
      "venues.contact.privacy": "Usaremos seus dados apenas para entrar em contato. Nada de spam.",
      "venues.header.pricing": "Preços",
      "audience.label": "Tenku para",
      "audience.players": "Jogadores",
      "audience.venues": "Quadras",
      "venues.header.login": "Entrar no painel",
      "venuesBand.eyebrow": "Para donos de quadras",
      "venuesBand.title": "Tem quadras? Gerencie com o Tenku",
      "venuesBand.text": "Reservas, pagamentos e clientes em um só lugar, pelo celular ou pelo computador. E os jogadores do Tenku podem te encontrar e reservar online.",
      "venuesBand.cta": "Conheça o Tenku para quadras",
      "venuesBand.login": "Entrar no painel",
      "venues.pricing.title": "Um Plano para Cada Quadra",
      "venues.pricing.subtitle": "Comece grátis e cresça no seu ritmo. Todos os preços são por unidade, com quadras ilimitadas.",
      "venues.pricing.billing": "Cobrança",
      "venues.pricing.monthly": "Mensal",
      "venues.pricing.yearly": "Anual",
      "venues.pricing.yearlySave": "2 meses grátis",
      "venues.pricing.recommended": "Recomendado",
      "venues.pricing.comingSoon": "Em breve",
      "venues.pricing.perMonth": "/mês",
      "venues.pricing.billedYearly": "{{amount}} cobrado por ano, por unidade",
      "venues.pricing.perBranch": "Por unidade, quadras ilimitadas",
      "venues.pricing.freeForever": "Grátis para sempre",
      "venues.pricing.ctaFree": "Criar conta grátis",
      "venues.pricing.ctaTrial": "Testar 2 meses grátis",
      "venues.pricing.ctaStart": "Começar agora",
      "venues.pricing.factTrial": "Ao se cadastrar, você ganha 2 meses de Pro grátis, sem cartão.",
      "venues.pricing.factData": "Se você mudar de plano, seus dados são mantidos.",
      "venues.pricing.factPayment": "Pague por transferência bancária.",
      "venues.pricing.demoQuestion": "Prefere ver antes?",
      "venues.pricing.demoLink": "Peça uma demonstração",
      "venues.pricing.free.name": "Free",
      "venues.pricing.free.tagline": "Apareça no Tenku e deixe o caderno.",
      "venues.pricing.free.f1": "Local verificado no app Tenku",
      "venues.pricing.free.f2": "Botão para os jogadores te chamarem no WhatsApp ou ligarem",
      "venues.pricing.free.f3": "Reservas manuais na lista do dia",
      "venues.pricing.free.f4": "Bloqueios de horário",
      "venues.pricing.free.f5": "Resumo do dia",
      "venues.pricing.free.f6": "1 publicação por mês no feed do Tenku (em breve)",
      "venues.pricing.starter.name": "Starter",
      "venues.pricing.starter.tagline": "Digitalize sua quadra e receba reservas pelo app.",
      "venues.pricing.starter.includes": "Tudo do Free, mais:",
      "venues.pricing.starter.f1": "Reservas pelo app Tenku",
      "venues.pricing.starter.f2": "Notificações de novas reservas",
      "venues.pricing.starter.f3": "Notificações para seus clientes do app",
      "venues.pricing.starter.f4": "Calendário semanal de todas as suas quadras",
      "venues.pricing.starter.f5": "Reservas a confirmar com prazo",
      "venues.pricing.starter.f6": "Horário fixo: reservas que se repetem toda semana",
      "venues.pricing.starter.f7": "Comprovantes de pagamento em cada reserva",
      "venues.pricing.starter.f8": "Até 2 usuários da equipe",
      "venues.pricing.starter.f9": "Relatórios até o mês, comparados com o período anterior",
      "venues.pricing.starter.f10": "O que o Tenku te trouxe: reservas e pagamentos pelo app",
      "venues.pricing.starter.f11": "4 publicações por mês no feed (em breve)",
      "venues.pricing.pro.name": "Pro",
      "venues.pricing.pro.tagline": "Opere seu local completo em um só painel.",
      "venues.pricing.pro.includes": "Tudo do Starter, mais:",
      "venues.pricing.pro.f1": "Loja: produtos, estoque, vendas e fechamento de caixa",
      "venues.pricing.pro.f2": "Eventos: reserve suas quadras e espaços para aniversários, empresas e mais",
      "venues.pricing.pro.f3": "Clientes: quem volta e quem parou de vir",
      "venues.pricing.pro.f4": "Promoções de fidelidade: a cada N horas jogadas, um prêmio",
      "venues.pricing.pro.f5": "Equipe ilimitada",
      "venues.pricing.pro.f6": "Relatórios completos: ocupação por dia e hora e horas não vendidas",
      "venues.pricing.pro.f7": "Oportunidades: faixas fracas e clientes para oferecer horário fixo",
      "venues.pricing.pro.f8": "Saldos a receber e o que você perdeu com faltas e cancelamentos",
      "venues.pricing.pro.f9": "Exportação em CSV",
      "venues.pricing.pro.f10": "Publicações ilimitadas no feed (em breve)",
      "venues.pricing.growth.name": "Growth",
      "venues.pricing.growth.tagline": "Encha seus horários e faça seu negócio crescer.",
      "venues.pricing.growth.includes": "Tudo do Pro, mais:",
      "venues.pricing.growth.f1": "Destaque no feed do Tenku",
      "venues.pricing.growth.f2": "Prioridade nas buscas do app",
      "venues.pricing.growth.f3": "Horas com desconto para encher os horários de baixa demanda",

      "sim.docTitle": "Simulador de chaves | Tenku",
      "sim.title": "Simulador de chaves",
      "sim.subtitle": "Monte seu torneio eliminatório antes de reservar a quadra: escolha equipes, formato e disponibilidade, e veja quantas partidas saem e a que horas tudo termina.",
      "sim.tournament": "Torneio",
      "sim.teams": "Equipes",
      "sim.formatByes": "Chave com byes",
      "sim.formatLL": "Repescagem",
      "sim.matchMin": "Partida (min)",
      "sim.restMin": "Intervalo entre partidas na quadra (min)",
      "sim.teamRestMin": "Descanso mínimo por equipe (min)",
      "sim.thirdPlace": "Disputa de 3º lugar",
      "sim.ceremony": "Premiação no encerramento",
      "sim.ceremonyMin": "Premiação (min)",
      "sim.courtsTitle": "Quadras e disponibilidade",
      "sim.court": "Quadra",
      "sim.addCourt": "+ Adicionar quadra",
      "sim.removeCourt": "Remover quadra",
      "sim.from": "de",
      "sim.to": "a",
      "sim.hintByes": "Chave de {{target}}; equipes com bye (avançam direto): {{byes}}; confrontos de primeira rodada: {{played}}.",
      "sim.hintByesNone": "Chave de {{target}}: sem byes, todos jogam a primeira rodada.",
      "sim.hintLL": "Com {{n}} equipes joga-se uma chave de {{target}} (equipes com bye na Rodada 1: {{byes}}) e o melhor perdedor da última rodada preliminar é repescado para completar {{phase}}.",
      "sim.hintLLNoByes": "Com {{n}} equipes joga-se uma chave de {{target}}: todos jogam desde a Rodada 1 e o melhor perdedor da última rodada preliminar é repescado para completar {{phase}}.",
      "sim.hintLLResolved": "Com {{n}} equipes a repescagem resolve para a chave normal (o preenchimento cai em potência de 2: chave de {{target}}).",
      "sim.phaseSemis": "as semifinais",
      "sim.phaseQuarters": "as quartas de final",
      "sim.phaseR16": "as oitavas de final",
      "sim.phaseR32": "os 16 avos de final",
      "sim.matches": "Partidas",
      "sim.rounds": "Rodadas",
      "sim.endsAt": "Tudo termina",
      "sim.playTime": "Tempo de jogo",
      "sim.warnNoFit": "{{count}} partidas ({{list}}) não cabem na disponibilidade atual. Amplie a janela de alguma quadra em uns {{min}} min, adicione uma quadra ou encurte as partidas.",
      "sim.schedTitle": "Cronograma por quadra",
      "sim.bracketTitle": "Estrutura da chave",
      "sim.noMatches": "sem partidas atribuídas",
      "sim.ceremonyLabel": "Premiação",
      "sim.thirdShort": "3º lugar",
      "sim.semiLosers": "Perdedores das semifinais",
      "sim.repechageNote": "Ao fechar a {{round}}, o organizador confirma no app o melhor perdedor repescado (margem de derrota, depois pontos, depois sorteio).",
      "sim.byeAdvances": "{{team}} avança direto",
      "sim.winnerOf": "Vencedor de {{id}}",
      "sim.prelimWinner": "Vencedor {{n}} da rodada anterior",
      "sim.luckyLoser": "Melhor perdedor",
      "sim.llBadge": "REP",
      "sim.roundN": "Rodada {{n}}",
      "sim.r64": "32 avos de final",
      "sim.r32": "16 avos de final",
      "sim.r16": "Oitavas",
      "sim.qf": "Quartas",
      "sim.sf": "Semifinais",
      "sim.final": "Final",
      "sim.matchOne": "1 partida",
      "sim.matchMany": "{{count}} partidas",
      "sim.ctaTitle": "Fechou? Crie no Tenku",
      "sim.ctaSubtitle": "Crie o torneio no app: sorteio automático, tabela de jogos, resultados e classificação ao vivo para todas as equipes.",
      "sim.ctaButton": "Criar meu torneio no Tenku",
      "sim.ctaStores": "Grátis na App Store e no Google Play",
      "sim.footNote": "Simulação com as mesmas regras de geração do Tenku; o sorteio no app define qual equipe cai em cada confronto.",

      // Refer
      "refer.pageTitle": "Indique um local e ganhe S/ 200 | Tenku",
      "refer.hero.badge": "Só no Peru",
      "refer.hero.title": "Indique um local e ganhe",
      "refer.hero.titleHighlight": "S/ 200",
      "refer.hero.subtitle": "Joga em um local que ainda não usa o Tenku? Convença o local a se cadastrar e ganhe S/ 200 quando ele começar um plano pago.",
      "refer.hero.ctaTerms": "Ver termos",
      "refer.how.title": "Como funciona",
      "refer.how.step1.title": "Fale com o seu local",
      "refer.how.step1.description": "Peça ao local onde você joga que se cadastre no Tenku para você reservar pelo app. Damos a mensagem pronta para enviar pelo WhatsApp.",
      "refer.how.step2.title": "O local se cadastra",
      "refer.how.step2.description": "Quando ele se cadastrar, avise a gente com o nome do local e o seu usuário. Confirmamos com o dono que foi você quem indicou.",
      "refer.how.step3.title": "Você recebe S/ 200",
      "refer.how.step3.description": "Quando o local completa 3 meses pagos ou contrata um plano anual, pagamos por Yape ou transferência bancária.",
      "refer.terms.title": "Termos e condições",
      "refer.terms.who.title": "Quem participa",
      "refer.terms.who.body": "Usuários do Tenku com 18 anos ou mais que moram no Peru.",
      "refer.terms.venues.title": "Quais locais contam",
      "refer.terms.venues.body": "Locais esportivos no Peru que não tenham conta no Tenku no momento da indicação.",
      "refer.terms.how.title": "Como indicar",
      "refer.terms.how.body": "Peça ao local que se cadastre no Tenku e escreva para support@tenkusports.com com o nome do local e o seu usuário. O Tenku confirma com o dono quem o indicou.",
      "refer.terms.when.title": "Quando você ganha",
      "refer.terms.when.body": "Você ganha S/ 200 quando o local indicado completa 3 meses pagos de qualquer plano, ou quando contrata um plano anual. O uso gratuito não conta para os 3 meses.",
      "refer.terms.once.title": "Um prêmio por local",
      "refer.terms.once.body": "É pago uma única vez por local, mesmo que tenha várias unidades. Se duas pessoas indicarem o mesmo local, o prêmio é de quem informou primeiro.",
      "refer.terms.payment.title": "Como é pago",
      "refer.terms.payment.body": "Por Yape ou transferência bancária, em até 15 dias após cumprida a condição.",
      "refer.terms.changes.title": "Mudanças",
      "refer.terms.changes.body": "O Tenku pode mudar ou encerrar esta promoção a qualquer momento. As indicações registradas antes da mudança mantêm as condições com que foram feitas.",
      "refer.share.cta": "Compartilhar com o local",
      "refer.share.message": "Olá, jogo no seu local e gostaria de reservar pelo Tenku. É um app para reservar quadras e organizar jogos e torneios, e organiza as suas reservas. Você pode começar grátis: https://tenkusports.com/venues",
      "refer.report.title": "O seu local se cadastrou?",
      "refer.report.description": "Escreva para nós com o nome do local e o seu usuário para registrar a sua indicação.",
      "refer.report.cta": "Avisar o Tenku",
      "refer.emailNote": "Você também pode escrever diretamente para",
      "refer.mail.subject": "Convenci um local",
      "refer.mail.body": "Nome do local:\nBairro:\n\nMeu nome:\nMeu usuário no Tenku:\nMeu celular:\n",
    }
  }
};

// Configuración de i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['es', 'en', 'pt'],
    load: 'languageOnly',
    debug: false,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;